import * as React from 'react';
import { Component } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import WoeUserLookupDataViewModel from '../ViewModels/WoeUserLookupDataViewModel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import EnrolmentFormViewModel from '../ViewModels/EnrolmentFormViewModel';
import SexDropDown from '../DropDowns/SexDropDown';
import TitleDropDown from '../DropDowns/TitleDropDown';
import FormControl from '@material-ui/core/FormControl';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Tooltip from '@material-ui/core/Tooltip';
import MaterialUIPickers from '../MaterialUIPickers';
import Button from '@material-ui/core/Button';
import StudentRelationshipDropDown from '../DropDowns/StudentRelationshipDropDown';
import EnrolmentPhotoCapture from './EnrolmentPhotoCapture';
import SignatureCanvas from 'react-signature-canvas'
import Address from '../Utility/Address';
import AddressSelectorViewModel from '../ViewModels/AddressSelectorViewModel';
import AccommodationTypeDropDown from '../DropDowns/AccommodationTypeDropDown';
import SchoolDropDown from '../DropDowns/SchoolDropDown';
import PriorAttainmentDropDown from '../DropDowns/PriorAttainmentDropDown';
import GradeDropDown from '../DropDowns/GradeDropDown';
import DeleteForever from '@material-ui/icons/DeleteForever'
import FSQuestion from '../Utility/FSQuestion';
import OccupationDropDown from '../DropDowns/OccupationDropDown';
import HEQualsDropDown from '../DropDowns/HEQualsDropDown';
import NationalityDropDown from '../DropDowns/NationalityDropDown';
import CountryDropDown from '../DropDowns/CountryDropDown';
import EthnicOriginDropDown from '../DropDowns/EthnicOriginDropDown';
import FirstLanguageDropDown from '../DropDowns/FirstLanguageDropDown';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import LearningDifficultyResponseDropDown from '../DropDowns/LearningDifficultyResponseDropDown';
import DisabilitySelectionViewModel from '../ViewModels/DisabilitySelectionViewModel';
import DisabilitySelection from '../Utility/DisabilitySelection';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormHelperText from '@material-ui/core/FormHelperText';
import EmploymentStatusDropDown from '../DropDowns/EmploymentStatusDropDown';
import EmploymentIntensityDropDown from '../DropDowns/EmploymentIntensityDropDown';
import EmploymentLengthDropDown from '../DropDowns/EmploymentLengthDropDown';
import BenifitStatusDropDown from '../DropDowns/BenifitStatusDropDown';
import InternetLimitDropDown from '../DropDowns/InternetLimitDropDown';
import Checkbox from '@material-ui/core/Checkbox';
import ArrowForward from '@material-ui/icons/ArrowForward';
import parser from 'fast-xml-parser';
import Alert from '@material-ui/lab/Alert/Alert';
import RadioValidatorElement from '../Utility/RadioValidatorElement';
import FakeRadioValidatorElement from '../Utility/FakeBooleanQuestion';
import RadioViewModel from '../ViewModels/RadioViewModel';
import RadioListValidatorElement from '../Utility/RadioListValidatorElement';
import moment from 'moment';

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    buttonItem: {
        marginTop: theme.spacing(2),
    },
    button: {
    },
    multiSelect: {
        marginLeft: "10px"
    }
});

interface IEnrolmentFormProps {
    model: WoeUserLookupDataViewModel;
    setComplete: (value) => void;
}

interface IEnrolmentFormState {
    model: EnrolmentFormViewModel;
    termTimeAddressDifferent: boolean;
    saving: boolean;
    privacyNoticeRead: boolean;
    phonesAndEmailsValid: boolean;
    phonesAndEmailsErrors: string;
    showPrivacyNoticeNote: boolean;
    formInvalid: boolean;
    disailityInvalid: boolean;
    feesAndFundingItems: RadioViewModel[];
    feesAndFundingWhoItems: RadioViewModel[];
}

export class EnrolmentForm extends Component<IEnrolmentFormProps & WithStyles<typeof styles>, IEnrolmentFormState> {
    public signatureRef;
    public signatureParentRef;

    constructor(props) {
        super(props);

        this.signatureRef = React.createRef();
        this.signatureParentRef = React.createRef();

        let newModel = new EnrolmentFormViewModel;
        newModel.dateofBirth = this.props.model.dateOfBirth;
        newModel.postcode = this.props.model.postcodeOut + ' ' + this.props.model.postcodeIn;
        newModel.postcodeOut = this.props.model.postcodeOut;
        newModel.postcodeIn = this.props.model.postcodeIn;
        newModel.offeringId = this.props.model.offeringId;
        newModel.enrolmentType = this.props.model.enrolmentType;
        newModel.academicYearId = this.props.model.academicYearId;

        let currFeesAndFundingItems = [
            { display: "I receive Jobseeker's Allowance (JSA)", value: "JSA" },
            { display: "I receive Employment and Support Allowance (ESA)", value: "ESA" },
            { display: "I receive Universal Credit (My take-home pay as recorded on my Universal Credit statement (disregarding benefits) is less than £338 a month (individual claims) or £541 a month (household claims))", value: "UC" },
            { display: "I receive other state benefits (My take-home pay (disregarding benefits) is less than £338 a month (individual claims) or £541 a month (household claims). I want to be employed or progress into more sustainable employment and the course I am enrolling on is directly relevant to my employment prospects and the local labour market need.", value: "other" },
            { display: "I am currently in work and my annual gross salary is less than £17004.00", value: "inWorkLowPay" },
            { display: "None of these apply", value: "none" }
        ];

        let currFeesAndFundingWhoItems = [
            { display: "I am paying the fees myself", value: "Me" },
            { display: "My employer (evidence required)", value: "Employer", title: 'A letter/email must be provided from your employer stating this' },
            { display: "I am paying my fees using Student Finance", value: "StudentFinance" }
        ];

        this.state = {
            model: newModel,
            termTimeAddressDifferent: false,
            saving: false,
            privacyNoticeRead: false,
            phonesAndEmailsValid: true,
            phonesAndEmailsErrors: '',
            showPrivacyNoticeNote: false,
            formInvalid: false,
            disailityInvalid: false,
            feesAndFundingItems: currFeesAndFundingItems,
            feesAndFundingWhoItems: currFeesAndFundingWhoItems
        };

        ValidatorForm.addValidationRule('isBoolTrue', (value) => {
            return (value === true || value === "true");
        });

        ValidatorForm.addValidationRule('isFirstForenameValid', (value) => {
            return (value === undefined || value === '' || /^([a-zA-Z-']){2,40}$/.test(value));
        });

        ValidatorForm.addValidationRule('isOtherForenameValid', (value) => {
            return (/^([a-zA-Z-' ]){0,30}$/.test(value));
        });

        ValidatorForm.addValidationRule('isSurnameValid', (value) => {
            return (/^([a-zA-Z-' ]){0,30}$/.test(value));
        });

        ValidatorForm.addValidationRule('isPhonesValidTel', (value) => {
            if ((this.state.model.mobilePhoneNumber !== undefined && this.state.model.mobilePhoneNumber.length > 0) ||
                (value !== undefined && value.length > 0)) {
                return true;
            } else {
                return false;
            }
        });

        ValidatorForm.addValidationRule('isPhonesValidMob', (value) => {
            if ((this.state.model.landlinePhoneNumber !== undefined && this.state.model.landlinePhoneNumber.length > 0) ||
                (value !== undefined && value.length > 0)) {
                return true;
            } else {
                return false;
            }
        });

        ValidatorForm.addValidationRule('isParent1PhonesValidTel', (value) => {
            if ((this.state.model.parent1WorkTel !== undefined && this.state.model.parent1WorkTel.length > 0) ||
                (value !== undefined && value.length > 0)) {
                return true;
            } else {
                return false;
            }
        });

        ValidatorForm.addValidationRule('isParent1PhonesValidWork', (value) => {
            if ((this.state.model.parent1HomeTel !== undefined && this.state.model.parent1HomeTel.length > 0) ||
                (value !== undefined && value.length > 0)) {
                return true;
            } else {
                return false;
            }
        });

        ValidatorForm.addValidationRule('isParent2PhonesValidTel', (value) => {
            if ((this.state.model.parent2WorkTel !== undefined && this.state.model.parent2WorkTel.length > 0) ||
                (value !== undefined && value.length > 0)) {
                return true;
            } else {
                return false;
            }
        });

        ValidatorForm.addValidationRule('isParent2PhonesValidWork', (value) => {
            if ((this.state.model.parent2HomeTel !== undefined && this.state.model.parent2HomeTel.length > 0) ||
                (value !== undefined && value.length > 0)) {
                return true;
            } else {
                return false;
            }
        });

        ValidatorForm.addValidationRule('isContactPhonesValidTel', (value) => {
            if ((this.state.model.contactMobilePhoneNumber !== undefined && this.state.model.contactMobilePhoneNumber.length > 0) ||
                (value !== undefined && value.length > 0)) {
                return true;
            } else {
                return false;
            }
        });

        ValidatorForm.addValidationRule('isContactPhonesValidMob', (value) => {
            if ((this.state.model.contactLandlinePhoneNumber !== undefined && this.state.model.contactLandlinePhoneNumber.length > 0) ||
                (value !== undefined && value.length > 0)) {
                return true;
            } else {
                return false;
            }
        });

        ValidatorForm.addValidationRule('isMobValid', (value) => {
            return (value === undefined || value === '' || (/^(\+44?7\d{3}|07\d{3}?)\d{3}\d{3}$/.test(value)));
        });

        ValidatorForm.addValidationRule('isTelValid', (value) => {
            return (value === undefined || value === '' || /^((02|[+]442)\d\d{4}\d{4})|((01|05|[+]441|[+]445)\d{2}?\d{3}\d{4})|((01|05|[+]441|[+]445)\d{3}\d{5,6})|((01|05|[+]441|[+]445)\d{4}\d{4,5})$/.test(value) ||
                /^(\+44?7\d{3}|07\d{3}?)\d{3}\d{3}$/.test(value));
        });

        ValidatorForm.addValidationRule('isEmailValid', (value) => {
            return (value === undefined || value === '' || /^[^@]+@[^\.]+\..+$/.test(value));
            //return this.verifyEmail(value);
        });

        ValidatorForm.addValidationRule('isNIValid', (value) => {
            return (/^[A-CEGHJ-PR-TW-Z]{1}[A-CEGHJ-NPR-TW-Z]{1}[0-9]{6}[A-D]{1}$/.test(value));
        });

        ValidatorForm.addValidationRule('isPSValid', (value) => {
            return (/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s[0-9][A-Za-z]{2})$/.test(value));
        });

        //ValidatorForm.addValidationRule('isPostcodeValid', (value) => {
        //    return (/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s[0-9][A-Za-z]{2})$/.test(value));
        //});

        ValidatorForm.addValidationRule('isContactFirstnameValid', (value) => {
            return (/^([a-zA-Z-']){2,20}$/.test(value));
        });

        ValidatorForm.addValidationRule('isContactSurnameValid', (value) => {
            return (/^([a-zA-Z-' ]){2,50}$/.test(value));
        });
    }

    public componentDidMount() {


    }

    public render() {
        var classes = this.props.classes;

        return (
            <React.Fragment>
                <Grid className={classes.root} container>

                    <Grid item xs={12}>
                        <Grid className={classes.root} container>
                            <Grid item xs={12}>
                                <Typography variant="h2">
                                    Enrolment
                            </Typography>

                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="h5">
                                    {this.props.model.academicYearId} - {this.props.model.code} - {this.props.model.name}
                                </Typography>
                                <br />
                            </Grid>

                        </Grid>
                    </Grid>

                    {this.state.phonesAndEmailsValid === false &&
                        <Grid item xs={12} >
                            <Alert severity="error" style={{ whiteSpace: "pre-line" }}>Save failed, as some of your contact details could not be verified. Please check the following fields and try again: {this.state.phonesAndEmailsErrors}</Alert>
                        </Grid>
                    }

                    <Grid item xs={12}>
                        <Grid className={classes.root} container alignItems="center" justify="center" style={{ marginBottom: '20px' }}>
                            <Grid item xs={12}>
                                <ValidatorForm onSubmit={this.save} onError={this.onError} autoComplete="off" instantValidate={true}>
                                    <Grid className={classes.root} container style={{ marginBottom: '20px', marginTop: '20px' }}>
                                        <Grid item xs={12}>
                                            <Typography variant="h4">
                                                {this.props.model.enrolmentType === "1416" ?
                                                    "Student/Your Child's Personal Details" :
                                                    "Personal Details"}
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <TitleDropDown
                                                required={true}
                                                name="title"
                                                childMode={(this.props.model.enrolmentType === "1416")}
                                                disabled={false}
                                                title={this.state.model.title}
                                                setTitle={this.setTitle}
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <TextValidator
                                                    label={this.props.model.enrolmentType !== "1416" ? "First Name *" : "Your Child's First Name *"}
                                                    name="firstForenames"
                                                    fullWidth
                                                    variant="outlined"
                                                    margin="normal"
                                                    value={this.state.model.firstForenames}
                                                    onChange={this.handleChange}
                                                    validators={['isFirstForenameValid', 'required']}
                                                    errorMessages={['First Name should be between 2 and 40 characters, and contain letters and hyphens only', 'This field is required']}
                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <TextValidator
                                                    label={this.props.model.enrolmentType !== "1416" ? "Other Names" : "Your Child's Other Names"}
                                                    name="otherForenames"
                                                    fullWidth
                                                    variant="outlined"
                                                    margin="normal"
                                                    value={this.state.model.otherForenames}
                                                    onChange={this.handleChange}
                                                    validators={['isOtherForenameValid']}
                                                    errorMessages={['Other Names should not exceed 30 characters, and contain letters, hyphens and spaces only']}
                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <TextValidator
                                                    label={this.props.model.enrolmentType !== "1416" ? "Surname *" : "Your Child's Surname *"}
                                                    name="surname"
                                                    fullWidth
                                                    variant="outlined"
                                                    margin="normal"
                                                    value={this.state.model.surname}
                                                    onChange={this.handleChange}
                                                    validators={['isSurnameValid', 'required']}
                                                    errorMessages={['Surname should not exceed 30 characters, and contain letters, hyphens and spaces only', 'This field is required']}
                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Tooltip title={this.props.model.enrolmentType !== "1416" ? "If you have more than one previous Surname, please enter the most recent" : "If your child has more than one previous Surname, please enter the most recent"} aria-label="If you have more than one previous Surname, please enter the most recent">
                                                <FormControl fullWidth>
                                                    <TextValidator
                                                        label={this.props.model.enrolmentType !== "1416" ? "Previous Surname" : "Your Child's Previous Surname"}
                                                        name="surnameAtBirth"
                                                        fullWidth
                                                        variant="outlined"
                                                        margin="normal"
                                                        value={this.state.model.surnameAtBirth}
                                                        onChange={this.handleChange}
                                                        validators={['isSurnameValid']}
                                                        errorMessages={['Previous Surname should not exceed 30 characters, and contain letters, hyphens and spaces only']}
                                                        tooltip={this.props.model.enrolmentType !== "1416" ? "If you have more than one previous Surname, please enter the most recent" : "If your child has more than one previous Surname, please enter the most recent"}
                                                    />
                                                </FormControl>
                                            </Tooltip>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <MaterialUIPickers
                                                label="Date of Birth *"
                                                valueKey="dateofBirth"
                                                updateValue={this.handleDateChange}
                                                date={this.state.model.dateofBirth}
                                                endDate={new Date(new Date().getFullYear() - 13, new Date().getMonth(), new Date().getDay())}

                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <TextValidator
                                                    label={this.props.model.enrolmentType === "1416" ? "Your Child's Mobile Phone" : "Mobile Phone"}
                                                    name="mobilePhoneNumber"
                                                    fullWidth
                                                    variant="outlined"
                                                    margin="normal"
                                                    value={this.state.model.mobilePhoneNumber}
                                                    onChange={this.handleChange}
                                                    onBlur={this.verifyPhone}
                                                    validators={['isPhonesValidMob', 'isMobValid']}
                                                    errorMessages={['Please provide at least one phone number', 'Please enter a valid mobile number']}
                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <TextValidator
                                                    label="Home Phone"
                                                    name="landlinePhoneNumber"
                                                    fullWidth
                                                    variant="outlined"
                                                    margin="normal"
                                                    value={this.state.model.landlinePhoneNumber}
                                                    onChange={this.handleChange}
                                                    validators={['isPhonesValidTel', 'isTelValid']}
                                                    errorMessages={['Please provide at least one phone number', 'Please enter a valid landline phone number (no spaces)']}
                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <TextValidator
                                                    label={this.props.model.enrolmentType === "1416" ? "Your Child's Email" : "Email"}
                                                    name="email"
                                                    fullWidth
                                                    variant="outlined"
                                                    margin="normal"
                                                    value={this.state.model.email}
                                                    onChange={this.handleChange}
                                                    onBlur={this.verifyEmail}
                                                    validators={this.props.model.enrolmentType === "1416" ? ['isEmailValid'] : ['isEmailValid', 'required']}
                                                    errorMessages={this.props.model.enrolmentType === "1416" ? ['Please enter a valid email address'] : ['Please enter a valid email address', 'This field is required']}
                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <SexDropDown disabled={false} sex={this.state.model.sex} setSex={this.setSex} childMode={this.props.model.enrolmentType === "1416"} />
                                        </Grid>
                                        
                                        {this.props.model.enrolmentType !== "1416" && this.state.model.dateofBirth !== undefined && Number(moment(this.state.model.dateofBirth).fromNow().slice(0, -10)) >= 19 && 
                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <TextValidator
                                                        label="National Insurance Number *"
                                                        name="nationalInsuranceNumber"
                                                        fullWidth
                                                        variant="outlined"
                                                        margin="normal"
                                                        value={this.state.model.nationalInsuranceNumber}
                                                        onChange={this.handleChange}
                                                        validators={['isNIValid', 'required']}
                                                        errorMessages={['Should be in format ‘AA123456A’ with no spaces', 'This field is required']}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        }
                                    </Grid>
                                    <hr />

                                    <Grid className={classes.root} container alignItems="center" justify="center">

                                        <Grid item xs={12}>
                                            <Address
                                                title={this.props.model.enrolmentType === "1416" ? "Your Child's Home Address" : "Primary Address"}
                                                setAddress={this.setPrimaryAddress}
                                                address1Label="First Line *"
                                                address2Label="Second Line"
                                                address3Label="Town/City *"
                                                address4Label="County *"
                                                addressPostcodeLabel="Postcode *"
                                                postcodeInProp="postcodeIn"
                                                postcodeOutProp="postcodeOut"
                                                postcodeProp="postcode"
                                                address1Prop="address1"
                                                address2Prop="address2"
                                                address3Prop="address3"
                                                address4Prop="address4"
                                            />
                                        </Grid>

                                        {this.props.model.enrolmentType === "HE" &&
                                            <React.Fragment>
                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="termTimeAddressDifferent"
                                                        value={this.state.termTimeAddressDifferent}
                                                        question="My term time address will be different to the specified address"
                                                        handleChange={this.handleDiffrentTermTimeAddressChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>

                                                {this.state.termTimeAddressDifferent &&
                                                    <React.Fragment>
                                                        <Grid item xs={12}>
                                                            <Address
                                                                title="Term Time Address"
                                                                setAddress={this.setTermTimeAddress}
                                                                address1Label="Term Time First Line"
                                                                address2Label="Term Time Second Line"
                                                                address3Label="Term Time Town/City"
                                                                address4Label="Term Time County"
                                                                addressPostcodeLabel="Term Time Postcode"
                                                                postcodeInProp="termTimePostcodeIn"
                                                                postcodeOutProp="termTimePostcodeOut"
                                                                postcodeProp="termTimePostcode"
                                                                address1Prop="termTimeAddress1"
                                                                address2Prop="termTimeAddress2"
                                                                address3Prop="termTimeAddress3"
                                                                address4Prop="termTimeAddress4"
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <FormControl fullWidth>
                                                                <TextValidator
                                                                    label="Term Time Telephone Number"
                                                                    name="termTimePhoneNumber"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    margin="normal"
                                                                    onBlur={this.verifyPhone}
                                                                    value={this.state.model.termTimePhoneNumber}
                                                                    onChange={this.handleChange}
                                                                    validators={['required', 'isTelValid']}
                                                                    errorMessages={['This field is required', 'Please enter a valid landline phone number']}
                                                                />
                                                            </FormControl>
                                                        </Grid>

                                                        
                                                    </React.Fragment>
                                                }   
                                                <Grid item xs={12}>
                                                    <AccommodationTypeDropDown setAccomodationType={this.setAccommodationType} accommodationType={this.state.model.accommodationType} disabled={false} />
                                                </Grid>
                                            </React.Fragment>
                                        }
                                    </Grid>
                                    <hr />
                                    {this.props.model.enrolmentType !== "1416" &&
                                        <Grid spacing={1} className={classes.root} container style={{ marginTop: '20px', marginBottom: '20px' }}>
                                            <Grid item xs={12}>
                                                <Typography variant="h4">
                                                    Emergency Contact
                                            </Typography>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <TextValidator
                                                        label="First Name"
                                                        name="contactFirstName"
                                                        fullWidth
                                                        variant="outlined"
                                                        margin="normal"
                                                        value={this.state.model.contactFirstName}
                                                        onChange={this.handleChange}
                                                        validators={['isContactFirstnameValid', 'required']}
                                                        errorMessages={['Emergency Contact First Name should be between 2 and 20 characters in length, and contain only letters and hyphens', 'This field is required']}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <TextValidator
                                                        label="Surname"
                                                        name="contactSurname"
                                                        fullWidth
                                                        variant="outlined"
                                                        margin="normal"
                                                        value={this.state.model.contactSurname}
                                                        onChange={this.handleChange}
                                                        validators={['isContactSurnameValid', 'required']}
                                                        errorMessages={['Emergency Contact Surname should be between 2 and 50 characters in length, and contain only letters, spaces and hyphens', 'This field is required']}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <StudentRelationshipDropDown required={true} childMode={this.props.model.enrolmentType === "1416"} enrolmentConfirmationMode={false} label="Relationship to You" disabled={false} propName="contactRelationship" studentRelationship={this.state.model.contactRelationship} setStudentRelationship={this.setStudentRelationship} />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <TextValidator
                                                        label="Mobile Phone"
                                                        name="contactMobilePhoneNumber"
                                                        fullWidth
                                                        variant="outlined"
                                                        margin="normal"
                                                        value={this.state.model.contactMobilePhoneNumber}
                                                        onChange={this.handleChange}
                                                        onBlur={this.verifyPhone}
                                                        validators={['isContactPhonesValidMob', 'isMobValid']}
                                                        errorMessages={['Please provide at least one phone number', 'Please enter a valid mobile number']}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <TextValidator
                                                        label="Home Phone"
                                                        name="contactLandlinePhoneNumber"
                                                        fullWidth
                                                        variant="outlined"
                                                        margin="normal"
                                                        onBlur={this.verifyPhone}
                                                        value={this.state.model.contactLandlinePhoneNumber}
                                                        onChange={this.handleChange}
                                                        validators={['isContactPhonesValidTel', 'isTelValid']}
                                                        errorMessages={['Please provide at least one phone number', 'Please enter a valid landline phone number']}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <TextValidator
                                                        label="Email"
                                                        name="contactEmail"
                                                        fullWidth
                                                        variant="outlined"
                                                        margin="normal"
                                                        value={this.state.model.contactEmail}
                                                        onChange={this.handleChange}
                                                        onBlur={this.verifyEmail}
                                                        validators={['isEmailValid']}
                                                        errorMessages={['Please enter a valid email address']}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    }
                                    {this.props.model.enrolmentType === "1416" &&
                                        <Grid spacing={1} className={classes.root} container>
                                            <Grid item xs={12}>
                                                <Typography variant="h4">
                                                    First Contact - Parent/Carer
                                                </Typography>
                                                <Typography variant="subtitle1">
                                                    This contact must have parental responsibility for the child.
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="No"
                                                    trueLabel="Yes"
                                                    name="parent1Responsibility"
                                                    value={this.state.model.parent1Responsibility}
                                                    question="Do you have parental responsibility for the student? *"
                                                    handleChange={this.handleRadioChange}
                                                    validators={['required', 'isBoolTrue']}
                                                    errorMessages={['This field is required', 'This parent/guardian must have parental responsibility']}
                                                />
                                            </Grid>

                                            {this.state.model.parent1Responsibility === true ?
                                                <React.Fragment>
                                                    <Grid item xs={12}>
                                                        <TitleDropDown
                                                            required={true}
                                                            name="parent1Title"
                                                            childMode={false}
                                                            disabled={false}
                                                            title={this.state.model.parent1Title}
                                                            setTitle={this.setParent1Title}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <FormControl fullWidth>
                                                            <TextValidator
                                                                label="First Name *"
                                                                name="parent1FirstName"
                                                                fullWidth
                                                                variant="outlined"
                                                                margin="normal"
                                                                value={this.state.model.parent1FirstName}
                                                                onChange={this.handleChange}
                                                                validators={['isFirstForenameValid', 'required']}
                                                                errorMessages={['First Name should be between 2 and 40 characters, and contain letters and hyphens only', 'This field is required']}
                                                            />
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <FormControl fullWidth>
                                                            <TextValidator
                                                                label="Surname *"
                                                                name="parent1Surname"
                                                                fullWidth
                                                                variant="outlined"
                                                                margin="normal"
                                                                value={this.state.model.parent1Surname}
                                                                onChange={this.handleChange}
                                                                validators={['isSurnameValid', 'required']}
                                                                errorMessages={['Surname should not exceed 30 characters, and contain letters, hyphens and spaces only', 'This field is required']}
                                                            />
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <StudentRelationshipDropDown required={true} enrolmentConfirmationMode={false} childMode={this.props.model.enrolmentType === "1416"} label="Relationship to your child *" propName="parentContactRelationship" disabled={false} studentRelationship={this.state.model.parentContactRelationship} setStudentRelationship={this.setParentContactRelationship} />
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <FormControl fullWidth>
                                                            <TextValidator
                                                                label="Number we should contact you on in the event of an emergency *"
                                                                name="parent1HomeTel"
                                                                fullWidth
                                                                variant="outlined"
                                                                margin="normal"
                                                                onBlur={this.verifyPhone}
                                                                value={this.state.model.parent1HomeTel}
                                                                onChange={this.handleChange}
                                                                validators={['required', 'isTelValid']}
                                                                errorMessages={['Please enter a valid phone number', 'Please enter a valid phone number']}
                                                            />
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <FormControl fullWidth>
                                                            <TextValidator
                                                                label="Mobile Phone"
                                                                name="parent1MobTel"
                                                                fullWidth
                                                                variant="outlined"
                                                                margin="normal"
                                                                value={this.state.model.parent1MobTel}
                                                                onChange={this.handleChange}
                                                                onBlur={this.verifyPhone}
                                                                validators={['isMobValid']}
                                                                errorMessages={['Please enter a valid mobile number']}
                                                            />
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <FormControl fullWidth>
                                                            <TextValidator
                                                                label="Work Phone"
                                                                name="parent1WorkTel"
                                                                fullWidth
                                                                variant="outlined"
                                                                margin="normal"
                                                                onBlur={this.verifyPhone}
                                                                value={this.state.model.parent1WorkTel}
                                                                onChange={this.handleChange}
                                                                validators={['isTelValid']}
                                                                errorMessages={['Please enter a valid landline phone number']}
                                                            />
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <FormControl fullWidth>
                                                            <TextValidator
                                                                label="Email *"
                                                                name="parent1EmailAddress"
                                                                fullWidth
                                                                variant="outlined"
                                                                margin="normal"
                                                                value={this.state.model.parent1EmailAddress}
                                                                onChange={this.handleChange}
                                                                validators={['isEmailValid', 'required']}
                                                                errorMessages={['Please enter a valid email address', 'This field is required']}
                                                            />
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <RadioValidatorElement
                                                            falseLabel="No"
                                                            trueLabel="Yes"
                                                            name="parent1LiveWithStudent"
                                                            value={this.state.model.parent1LiveWithStudent}
                                                            question="Does the student live with this parent? *"
                                                            handleChange={this.handleRadioChange}
                                                            validators={['required']}
                                                            errorMessages={['This field is required']}
                                                        />
                                                    </Grid>

                                                    {this.state.model.parent1LiveWithStudent == false &&
                                                        <Grid item xs={12}>
                                                            <Address
                                                                title="First Parent Address"
                                                                setAddress={this.setParent1Address}
                                                                address1Label="First Line *"
                                                                address2Label="Second Line"
                                                                address3Label="Town/City *"
                                                                address4Label="County *"
                                                                addressPostcodeLabel="Postcode *"
                                                                postcodeInProp="parent1PostcodeIn"
                                                                postcodeOutProp="parent1PostcodeOut"
                                                                postcodeProp="parent1Postcode"
                                                                address1Prop="parent1Address1"
                                                                address2Prop="parent1Address2"
                                                                address3Prop="parent1Address3"
                                                                address4Prop="parent1Address4"
                                                            />
                                                        </Grid>
                                                    }
                                                </React.Fragment>
                                                :
                                                <React.Fragment />
                                            }
                                        </Grid>
                                    }

                                    {this.props.model.enrolmentType === "1416" &&
                                        <Grid spacing={1} className={classes.root} container style={{ marginTop: '20px', marginBottom: '20px' }}>
                                            <Grid item xs={12}>
                                                <Typography variant="h4">
                                                    Second Contact - Parent/Carer
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="No"
                                                    trueLabel="Yes"
                                                    name="parent2Responsibility"
                                                    value={this.state.model.parent2Responsibility}
                                                    question="Do you have parental responsibility for the student?"
                                                    handleChange={this.handleRadioChange}
                                                />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TitleDropDown required={false} name="parent2Title" childMode={false} disabled={false} title={this.state.model.parent2Title} setTitle={this.setParent2Title} />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <TextValidator
                                                        label="First Name"
                                                        name="parent2FirstName"
                                                        fullWidth
                                                        variant="outlined"
                                                        margin="normal"
                                                        value={this.state.model.parent2FirstName}
                                                        onChange={this.handleChange}
                                                        validators={['isFirstForenameValid']}
                                                        errorMessages={['First Name should be between 2 and 40 characters, and contain letters and hyphens only']}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <TextValidator
                                                        label="Surname"
                                                        name="parent2Surname"
                                                        fullWidth
                                                        variant="outlined"
                                                        margin="normal"
                                                        value={this.state.model.parent2Surname}
                                                        onChange={this.handleChange}
                                                        validators={['isSurnameValid']}
                                                        errorMessages={['Surname should not exceed 30 characters, and contain letters, hyphens and spaces only']}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <StudentRelationshipDropDown required={false} enrolmentConfirmationMode={false} childMode={this.props.model.enrolmentType === "1416"} label="Relationship to your child" propName="parent2ContactRelationship" disabled={false} studentRelationship={this.state.model.parent2ContactRelationship} setStudentRelationship={this.setParent2ContactRelationship} />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <TextValidator
                                                        label="Number we should contact you on in case of emergency"
                                                        name="parent2HomeTel"
                                                        fullWidth
                                                        variant="outlined"
                                                        margin="normal"
                                                        onBlur={this.verifyPhone}
                                                        value={this.state.model.parent2HomeTel}
                                                        onChange={this.handleChange}
                                                        validators={['isTelValid']}
                                                        errorMessages={['Please enter a valid landline phone number']}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <TextValidator
                                                        label="Mobile Phone"
                                                        name="parent2MobTel"
                                                        fullWidth
                                                        variant="outlined"
                                                        margin="normal"
                                                        value={this.state.model.parent2MobTel}
                                                        onChange={this.handleChange}
                                                        onBlur={this.verifyPhone}
                                                        validators={['isMobValid']}
                                                        errorMessages={['Please enter a valid mobile number']}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <TextValidator
                                                        label="Work Phone"
                                                        name="parent2WorkTel"
                                                        fullWidth
                                                        variant="outlined"
                                                        margin="normal"
                                                        onBlur={this.verifyPhone}
                                                        value={this.state.model.parent2WorkTel}
                                                        onChange={this.handleChange}
                                                        validators={['isTelValid']}
                                                        errorMessages={['Please enter a valid landline phone number']}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextValidator
                                                    label="Email"
                                                    name="parent2EmailAddress"
                                                    fullWidth
                                                    variant="outlined"
                                                    margin="normal"
                                                    value={this.state.model.parent2EmailAddress}
                                                    onChange={this.handleChange}
                                                    validators={['isEmailValid']}
                                                    errorMessages={['Please enter a valid email address']}
                                                />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="No"
                                                    trueLabel="Yes"
                                                    name="parent2LiveWithStudent"
                                                    value={this.state.model.parent2LiveWithStudent}
                                                    question="Does the student live with this parent?"
                                                    handleChange={this.handleRadioChange}
                                                />
                                            </Grid>

                                            {this.state.model.parent2LiveWithStudent == false &&
                                                <Grid item xs={12}>
                                                    <Address
                                                        title="Second Parent Address"
                                                        setAddress={this.setParent2Address}
                                                        address1Label="First Line *"
                                                        address2Label="Second Line"
                                                        address3Label="Town/City *"
                                                        address4Label="County *"
                                                        addressPostcodeLabel="Postcode *"
                                                        postcodeInProp="parent2PostcodeIn"
                                                        postcodeOutProp="parent2PostcodeOut"
                                                        postcodeProp="parent2Postcode"
                                                        address1Prop="parent2Address1"
                                                        address2Prop="parent2Address2"
                                                        address3Prop="parent2Address3"
                                                        address4Prop="parent2Address4"
                                                    />
                                                </Grid>
                                            }
                                        </Grid>
                                    }
                                    <hr />
                                    <Grid spacing={1} className={classes.root} container style={{ marginTop: '20px', marginBottom: '20px' }}>
                                        <Grid item xs={12}>
                                            <Typography variant="h4">
                                                Previous Education / Qualifications
                                            </Typography>
                                        </Grid>

                                        {this.props.model.enrolmentType !== "HE" &&
                                            <React.Fragment>
                                                <Grid item xs={12}>
                                                    <SchoolDropDown childMode={this.props.model.enrolmentType === "1416"} disabled={false} school={this.state.model.school} setSchool={this.setSchool} />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <MaterialUIPickers
                                                        label="Attended School From *"
                                                        valueKey="schoolAttendedFrom"
                                                        updateValue={this.handleDateChange}
                                                        date={this.state.model.schoolAttendedFrom}
                                                    />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <MaterialUIPickers
                                                        label="Attended School To *"
                                                        valueKey="schoolAttendedTo"
                                                        updateValue={this.handleDateChange}
                                                        date={this.state.model.schoolAttendedTo}
                                                    />
                                                </Grid>
                                            </React.Fragment>
                                        }

                                        {this.props.model.enrolmentType === "FE" &&
                                            <React.Fragment>
                                                <Grid item xs={12}>
                                                    <PriorAttainmentDropDown disabled={false} priorAttainment={this.state.model.priorAttainment} setPriorAttainment={this.setPriorAttianment} />
                                                </Grid>



                                                <Grid item xs={12}>
                                                    <GradeDropDown disabled={false} gradeType="Eng" grade={this.state.model.gcseEnglishGrade} label="What is your highest prior GCSE English Language grade?" setGrade={this.setEnglishGrade} />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    {this.state.model.gcseEnglishGrade !== undefined &&
                                                        <FSQuestion disabled={false} fsQuestion={this.state.model.englishFSQuestion} grade={this.state.model.gcseEnglishGrade} subject="English Language" setFSQuestion={this.setEnglishFSQuestion} />
                                                    }
                                                </Grid>

                                                {this.state.model.gcseEnglishGradeAskLevel2 &&
                                                    <Grid item xs={12}>
                                                        <RadioValidatorElement
                                                            falseLabel="No"
                                                            trueLabel="Yes"
                                                            name="englishByEndOfYear11"
                                                            value={this.state.model.englishByEndOfYear11}
                                                            question="Did you achieve a English Language GCSE Grade 4/C or above by the end of year 11?"
                                                            handleChange={this.handleRadioChange}
                                                            validators={['required']}
                                                            errorMessages={['This field is required']}
                                                        />
                                                    </Grid>
                                                }

                                                <Grid item xs={12}>
                                                    <GradeDropDown disabled={false} gradeType="EngLit" grade={this.state.model.gcseEnglishLitGrade} label="What is your highest prior GCSE English Literature grade?" setGrade={this.setEnglishLitGrade} />
                                                </Grid>

                                                {/*
                                                    <Grid item xs={12}>
                                                        {this.state.model.gcseEnglishLitGrade !== undefined &&
                                                            <FSQuestion disabled={false} fsQuestion={this.state.model.englishLitFSQuestion} grade={this.state.model.gcseEnglishLitGrade} subject="English Literature" setFSQuestion={this.setEnglishLitFSQuestion} />
                                                        }
                                                </Grid>
                                                */}

                                                {this.state.model.gcseEnglishLitGradeAskLevel2 &&
                                                    <Grid item xs={12}>
                                                        <RadioValidatorElement
                                                            falseLabel="No"
                                                            trueLabel="Yes"
                                                            name="englishLitByEndOfYear11"
                                                            value={this.state.model.englishLitByEndOfYear11}
                                                            question="Did you achieve a English Literature GCSE Grade 4/C or above by the end of year 11?"
                                                            handleChange={this.handleRadioChange}
                                                            validators={['required']}
                                                            errorMessages={['This field is required']}
                                                        />
                                                    </Grid>
                                                }

                                                <Grid item xs={12}>
                                                    <GradeDropDown disabled={false} gradeType="Maths" grade={this.state.model.gcseMathsGrade} label="What is your highest prior GCSE Maths grade?" setGrade={this.setMathsGrade} />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    {this.state.model.gcseMathsGrade !== undefined &&
                                                        <FSQuestion disabled={false} fsQuestion={this.state.model.mathsFSQuestion} grade={this.state.model.gcseMathsGrade} subject="Maths" setFSQuestion={this.setMathsFSQuestion} />
                                                    }
                                                </Grid>

                                                {this.state.model.gcseMathsGradeAskLevel2 &&
                                                    <Grid item xs={12}>
                                                        <RadioValidatorElement
                                                            falseLabel="No"
                                                            trueLabel="Yes"
                                                            name="mathsByEndOfYear11"
                                                            value={this.state.model.mathsByEndOfYear11}
                                                            question="Did you achieve a Maths GCSE Grade 4/C or above by the end of year 11?"
                                                            handleChange={this.handleRadioChange}
                                                            validators={['required']}
                                                            errorMessages={['This field is required']}
                                                        />
                                                    </Grid>
                                                }
                                            </React.Fragment>
                                        }

                                        {this.props.model.enrolmentType === "HE" &&
                                            <React.Fragment>
                                                <Grid item xs={12}>
                                                    <HEQualsDropDown disabled={false} heQuals={this.state.model.heQuals} setHEQualsDropDown={this.setHEQuals} />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <TextValidator
                                                        label="What is the title of your highest level qualification?"
                                                        name="hEQualTitle"
                                                        fullWidth
                                                        variant="outlined"
                                                        margin="normal"
                                                        value={this.state.model.hEQualTitle}
                                                        onChange={this.handleChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>
                                            </React.Fragment>
                                        }

                                        {(this.props.model.enrolmentType === "HE" || this.props.model.enrolmentType === "FE") &&
                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="No"
                                                    trueLabel="Yes"
                                                    name="previousExamConcessions"
                                                    value={this.state.model.previousExamConcessions}
                                                    question="Have you had exam concessions in the past?"
                                                    handleChange={this.handleRadioChange}
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                />
                                            </Grid>
                                        }
                                    </Grid>
                                    <hr />
                                    <Grid spacing={1} className={classes.root} container style={{ marginTop: '20px', marginBottom: '20px' }}>
                                        <Grid item xs={12}>
                                            <Typography variant="h4">
                                                Additional Information
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <NationalityDropDown childMode={this.props.model.enrolmentType === "1416"} disabled={false} nationality={this.state.model.nationality} setNationalityDropDown={this.setNationality} />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <CountryDropDown childMode={this.props.model.enrolmentType === "1416"} disabled={false} country={this.state.model.country} setCountry={this.setCountry} />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <RadioValidatorElement
                                                falseLabel="No"
                                                trueLabel="Yes"
                                                name="euroResident"
                                                value={this.state.model.euroResident}
                                                question={this.props.model.enrolmentType === "1416" ? "If you have said your child lives in the UK or European Economic Area (EEA) , have they always lived here? *" : "If you have said you live in the UK or European Economic Area (EEA) , have you always lived here? *"}
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        </Grid>

                                        {this.state.model.euroResident === false &&
                                            <Grid item xs={12}>
                                                <MaterialUIPickers
                                                    label={this.props.model.enrolmentType === "1416" ? "When did your child move to the UK? *" : "When did you move to the UK? *"}
                                                    valueKey="euroResidentDate"
                                                    updateValue={this.handleDateChange}
                                                    date={this.state.model.euroResidentDate}
                                                />
                                            </Grid>
                                        }

                                        <Grid item xs={12}>
                                            <EthnicOriginDropDown childMode={this.props.model.enrolmentType == "1416"} disabled={false} ethnicGroup={this.state.model.ethnicOrigin} setEthnicGroup={this.setEthnicGroup} />
                                        </Grid>

                                        {this.props.model.enrolmentType === "1416" &&
                                            <React.Fragment>
                                                <Grid item xs={12}>
                                                    <FirstLanguageDropDown disabled={false} firstLanguage={this.state.model.firstLanguage} setFirstLanguage={this.setFirstLanguage} />
                                                </Grid>


                                                <Grid item xs={12}>
                                                    <FormControl fullWidth>
                                                        <TextValidator
                                                            label="What other languages does your child speak?"
                                                            name="extraLanguages"
                                                            fullWidth
                                                            variant="outlined"
                                                            margin="normal"
                                                            value={this.state.model.extraLanguages}
                                                            onChange={this.handleChange}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </React.Fragment>
                                        }
                                        {this.props.model.enrolmentType !== "1416" &&
                                            <Grid item xs={12}>

                                                <FormControl component="fieldset">
                                                    <FormLabel component="legend">Which of these options best reflect your current household situation?</FormLabel>
                                                    <RadioGroup aria-label="Household Situation" name="householdSituation" value={this.state.model.householdSituation} onChange={this.handleHouseholdSituationChange} className={classes.multiSelect}>
                                                        <FormControlLabel value="1" label="1. In my home, nobody is employed and there is at least one dependent child" control={<Radio />} />
                                                        <FormControlLabel value="2" label="2. In my home, nobody is employed and there are no dependent children" control={<Radio />} />
                                                        <FormControlLabel value="3" label="3. In my home, I am a single adult with at least one dependent child" control={<Radio />} />
                                                        <FormControlLabel value="1,3" label="4. Option 1 and option 3 both apply to me" control={<Radio />} />
                                                        <FormControlLabel value="98" label="5. I prefer not to say" control={<Radio />} />
                                                        <FormControlLabel value="99" label="6. None of these situations apply to me" control={<Radio />} />
                                                    </RadioGroup>
                                                </FormControl>
                                            </Grid>
                                        }

                                        {this.props.model.enrolmentType === "1416" &&
                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="No"
                                                    trueLabel="Yes"
                                                    name="armedForces"
                                                    value={this.state.model.armedForces}
                                                    question="Are you now or have you previously served as a member of the armed forces? *"
                                                    handleChange={this.handleRadioChange}
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                />
                                            </Grid>
                                        }

                                        {this.props.model.enrolmentType === "1416" &&
                                            <React.Fragment>
                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="localAuthorityCare"
                                                        value={this.state.model.localAuthorityCare}
                                                        question="My child is currently in the care of the Local Authority *"
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>


                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="careLeaver"
                                                        value={this.state.model.careLeaver}
                                                        question="My child left care *"
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="youngCarer"
                                                        value={this.state.model.youngCarer}
                                                        question="My child is a young carer *"
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="freeSchoolMeals"
                                                        value={this.state.model.freeSchoolMeals}
                                                        question="My child currently recieves Free School Meals *"
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="previousFreeSchoolMeals"
                                                        value={this.state.model.previousFreeSchoolMeals}
                                                        question="Has your child recieved Free School Meals in the last 6 years? *"
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="photoPermission1416"
                                                        value={this.state.model.photoPermission1416}
                                                        question="Do you give permission for any photographs/images/video of your child to be reproduced for either use in lessons or display/public purposes? *"
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>
                                            </React.Fragment>
                                        }

                                        {this.props.model.enrolmentType === "HE" &&
                                            <Grid item xs={12}>
                                                <OccupationDropDown disabled={false} occupation={this.state.model.occupation} setOccupation={this.setOccupation} label={this.state.model.dateofBirth !== undefined && this.state.model.dateofBirth > new Date(new Date().setFullYear(new Date().getFullYear() - 21)) ?
                                                    "Please provide the occupation of your highest paid parent/guardian. If they are unemployed/retired, please provide the most recent occupation." :
                                                    "Please provide your occupation"} />
                                            </Grid>
                                        }
                                    </Grid>
                                    <hr />
                                    <Grid spacing={1} className={classes.root} container style={{ marginTop: '20px', marginBottom: '20px' }}>
                                        <Grid item xs={12}>
                                            <Typography variant="h4">
                                                Learning Support Information
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <LearningDifficultyResponseDropDown childMode={this.props.model.enrolmentType === "1416"} disabled={false} learningDifficultyResponse={this.state.model.learningDifficultyDisabilityResponse} setLearningDifficultyResponse={this.setLearningDifficultyResponse} />
                                        </Grid>

                                        {this.state.model.learningDifficultyDisabilityResponse === "1" &&
                                            <React.Fragment>
                                                <Grid item xs={12}>
                                                    <DisabilitySelection key="disabilitySelection" disabled={false} setDisabilitySelection={this.setDisabilities} />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="alsRequested"
                                                        value={this.state.model.alsRequested}
                                                        question={this.props.model.enrolmentType === "1416" ? "Does your child need any support in regards to the information declared above? *" : "Do you need any support in regards to the information declared above? *"}
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>

                                                {this.props.model.enrolmentType !== "1416" &&
                                                    <Grid item xs={12}>
                                                        <RadioValidatorElement
                                                            falseLabel="No"
                                                            trueLabel="Yes"
                                                            name="hasEHCP"
                                                            value={this.state.model.hasEHCP}
                                                            question="Do you hold a current Education Health Care plan?"
                                                            handleChange={this.handleRadioChange}
                                                            validators={['required']}
                                                            errorMessages={['This field is required']}
                                                        />
                                                    </Grid>
                                                }


                                            </React.Fragment>
                                        }

                                        {this.props.model.enrolmentType === "1416" &&
                                            <React.Fragment>
                                                <Grid item xs={12}>
                                                    <FormControl fullWidth>
                                                        <TextValidator
                                                            label="Does your child have any medical conditions?"
                                                            name="medicalConditions"
                                                            fullWidth
                                                            variant="outlined"
                                                            margin="normal"
                                                            value={this.state.model.medicalConditions}
                                                            onChange={this.handleChange}
                                                            placeholder="eg: epilepsy, asthma, diabetes, etc., please give details"
                                                        />
                                                    </FormControl>
                                                </Grid>


                                                <Grid item xs={12}>
                                                    <FormControl fullWidth>
                                                        <TextValidator
                                                            label="Does your child take any medication?"
                                                            name="medication"
                                                            fullWidth
                                                            variant="outlined"
                                                            margin="normal"
                                                            value={this.state.model.medication}
                                                            onChange={this.handleChange}
                                                        />
                                                        <FormHelperText>If your child suffers from asthma, please give details of the type of inhalers used. An inhaler should also be stored at the 14-16 College in a bag with the child's name.</FormHelperText>
                                                    </FormControl>
                                                </Grid>
                                            </React.Fragment>
                                        }
                                    </Grid>
                                    <hr />
                                    {this.props.model.enrolmentType !== "1416" &&
                                        <React.Fragment>
                                            <Grid spacing={1} className={classes.root} container style={{ marginTop: '20px', marginBottom: '20px' }}>
                                                <Grid item xs={12}>
                                                    <Typography variant="h4">
                                                        Employment Information
                                            </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <EmploymentStatusDropDown disabled={false} employmentStatus={this.state.model.employmentStatus} setEmploymentStatus={this.setEmploymentStatus} />
                                                </Grid>
                                                {this.state.model.employmentStatus === "10" &&
                                                    <React.Fragment>
                                                        <Grid item xs={12}>
                                                            <RadioValidatorElement
                                                                falseLabel="Employed"
                                                                trueLabel="Self-employed"
                                                                name="isSelfEmployed"
                                                                value={this.state.model.isSelfEmployed}
                                                                question="What kind of employment were you in?"
                                                                handleChange={this.handleRadioChange}
                                                                validators={['required']}
                                                                errorMessages={['This field is required']}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <EmploymentIntensityDropDown disabled={false} employmentIntensity={this.state.model.employmentIntensity} setEmploymentIntensity={this.setEmploymentIntensity} />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <EmploymentLengthDropDown disabled={false} employmentLength={this.state.model.employmentLength} setEmploymentLength={this.setEmploymentLength} label="Length of time in this employment" unemploymentMode={false} />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <MaterialUIPickers
                                                                label="From what date were you employed?"
                                                                valueKey="employedFrom"
                                                                updateValue={this.handleDateChange}
                                                                date={this.state.model.employedFrom}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <RadioValidatorElement
                                                                falseLabel="No"
                                                                trueLabel="Yes"
                                                                name="fullTimeEducation"
                                                                value={this.state.model.fullTimeEducation}
                                                                question="Were you also in full time education/training?"
                                                                handleChange={this.handleRadioChange}
                                                                validators={['required']}
                                                                errorMessages={['This field is required']}
                                                            />
                                                        </Grid>
                                                    </React.Fragment>
                                                }
                                                {(this.state.model.employmentStatus === "11" || this.state.model.employmentStatus === "12") &&
                                                    <React.Fragment>
                                                        <Grid item xs={12}>
                                                            <EmploymentLengthDropDown disabled={false} employmentLength={this.state.model.unemploymentLength} setEmploymentLength={this.setUnemploymentLength} label="Length of time out of work" unemploymentMode={true} />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <MaterialUIPickers
                                                                label="From what date were you unemployed?"
                                                                valueKey="unemployedFrom"
                                                                updateValue={this.handleDateChange}
                                                                date={this.state.model.unemployedFrom}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <RadioValidatorElement
                                                                falseLabel="No"
                                                                trueLabel="Yes"
                                                                name="fullTimeEducation"
                                                                value={this.state.model.fullTimeEducation}
                                                                question="Were you also in full time education/training?"
                                                                handleChange={this.handleRadioChange}
                                                                validators={['required']}
                                                                errorMessages={['This field is required']}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <BenifitStatusDropDown disabled={false} benifitStatus={this.state.model.benifitsStatus} setBenifitStatus={this.setBenifitStatus} />
                                                        </Grid>
                                                    </React.Fragment>
                                                }

                                            </Grid>
                                            <hr />
                                        </React.Fragment>
                                    }


                                    <Grid spacing={1} className={classes.root} container style={{ marginTop: '20px', marginBottom: '20px' }}>
                                        <Grid item xs={12}>
                                            <Typography variant="h4">
                                                Safeguarding
                                                    </Typography>
                                            <Typography variant="subtitle1">
                                                All students are asked to disclose if they have any criminal convictions when they apply and enrol with Hull College Group, unless exempt under the Rehabilitation of Offenders Act (1974). It is also your responsibility to inform your tutor or a designated safeguarding officer (DSO) if you are charged with, or convicted of a criminal offence during your course of study for an offence which has not been previously disclosed.
                                                    </Typography>
                                            <Typography variant="subtitle1">
                                                The Rehabilitation of Offenders Act 1974 does not always apply, this is because of the college’s safeguarding duties for children and vulnerable adults. This therefore allows us to request information for any unspent or spent sentences where applicants are studying courses, or involved in college activities or work placements, with children, young people or adults at risk.
                                                    </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <RadioValidatorElement
                                                falseLabel="No"
                                                trueLabel="Yes"
                                                name="criminalConviction"
                                                value={this.state.model.criminalConviction}
                                                question={this.props.model.enrolmentType !== "1416" ?
                                                    "Do you have any criminal convictions, cautions, reprimands, final warnings or prosecutions pending? *" :
                                                    "Does your child have any criminal convictions, cautions, reprimands, final warnings or prosecutions pending? *"
                                                }
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        </Grid>
                                    </Grid>
                                    <hr />
                                    {(this.props.model.enrolmentType === "FE" || this.props.model.enrolmentType === "HE") &&
                                        <React.Fragment>
                                            <Grid spacing={1} className={classes.root} container style={{ marginTop: '20px', marginBottom: '20px' }}>
                                                <Grid item xs={12}>
                                                    <Typography variant="h4">
                                                        Fees and Funding Assessment
                                                    </Typography>
                                                </Grid>

                                                {this.props.model.enrolmentType === "FE" &&
                                                    <RadioListValidatorElement validators={['required']} errorMessages={['This field is required']} options={this.state.feesAndFundingItems} name="feesAndFunding" value={this.state.model.feesAndFunding} handleChange={this.handleFeesAndFundingChange} question="Which of these options apply to you/your household?"/>
                                                }

                                                {this.props.model.enrolmentType === "HE" &&
                                                    <RadioListValidatorElement validators={['required']} errorMessages={['This field is required']} options={this.state.feesAndFundingWhoItems} name="feesAndFundingSource" value={this.state.model.feesAndFundingSource} handleChange={this.handleFeesAndFundingSourceChange} question="Who will be paying for your fees?" />   
                                                }
                                            </Grid>
                                            <hr />
                                        </React.Fragment>
                                    }

                                    <Grid spacing={1} className={classes.root} container style={{ marginTop: '20px', marginBottom: '20px' }}>
                                        <Grid item xs={12}>
                                            <Typography variant="h4">
                                                Covid 19
                                            </Typography>
                                            {this.props.model.enrolmentType !== "1416" ?
                                                <React.Fragment>
                                                    <Typography variant="subtitle1">
                                                        Your College experience this year is likely to be very different to any previous learning you have completed.
                                                    </Typography>
                                                    <Typography variant="subtitle1">
                                                        To support you on your course we have a series of questions that will allow us to better tailor that support.
                                                    </Typography>
                                                    <Typography variant="subtitle1">
                                                        Online learning is likely going to be a much larger part of your course. To be able to support you with this, please let us know which of the following you have access to.
                                                    </Typography>
                                                </React.Fragment>
                                                :
                                                <React.Fragment>
                                                    <Typography variant="subtitle1">
                                                        Things may be a little different for a while and to enable us to support your child during their studies please let us know if they have access to the following:
                                                   </Typography>
                                                </React.Fragment>
                                            }
                                        </Grid>
                                        <Grid item xs={12}>
                                            <RadioValidatorElement
                                                falseLabel="No"
                                                trueLabel="Yes"
                                                name="ownTablet"
                                                value={this.state.model.ownTablet}
                                                question={this.props.model.enrolmentType == "1416" ? "Does your child have access to a tablet? *" : "Do you have access to a tablet? *"}
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        </Grid>
                                        {this.state.model.ownTablet &&
                                            <RadioValidatorElement
                                                falseLabel="No - the device is my own"
                                                trueLabel="Yes"
                                                name="ownTabletShared"
                                                value={this.state.model.ownTabletShared}
                                                question="Is the tablet a shared/family device? *"
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        }
                                        {this.props.model.enrolmentType !== "1416" && this.state.model.ownTabletShared &&
                                            <RadioValidatorElement
                                                falseLabel="No"
                                                trueLabel="Yes"
                                                name="ownTabletUninterrupted"
                                                value={this.state.model.ownTabletUninterrupted}
                                                question={this.props.model.enrolmentType == "1416" ?
                                                    "A week of Online learning work can be up to 20 hours a week (4 hours a day). Will your child be able to use this device uninterrupted for that length of time? *"
                                                    : "A week of Online learning work can be up to 20 hours a week (4 hours a day). Will be able to use this device uninterrupted for that length of time? *"}
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        }
                                        <Grid item xs={12}>
                                            <RadioValidatorElement
                                                falseLabel="No"
                                                trueLabel="Yes"
                                                name="ownLaptop"
                                                value={this.state.model.ownLaptop}
                                                question={this.props.model.enrolmentType == "1416" ? "Does your child have access to a Laptop/MacBook? *" : "Do you have access to a Laptop/MacBook? *"}
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        </Grid>
                                        {this.state.model.ownLaptop &&
                                            <RadioValidatorElement
                                                falseLabel="No - the device is my own"
                                                trueLabel="Yes"
                                                name="ownLaptopShared"
                                                value={this.state.model.ownLaptopShared}
                                                question="Is the laptop a shared/family device? *"
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        }
                                        {this.props.model.enrolmentType !== "1416" && this.state.model.ownLaptopShared &&
                                            <RadioValidatorElement
                                                falseLabel="No"
                                                trueLabel="Yes"
                                                name="ownLaptopUninterrupted"
                                                value={this.state.model.ownLaptopUninterrupted}
                                                question={this.props.model.enrolmentType == "1416" ?
                                                    "A week of Online learning work can be up to 20 hours a week (4 hours a day). Will your child be able to use this device uninterrupted for that length of time? *"
                                                    : "A week of Online learning work can be up to 20 hours a week (4 hours a day). Will you be able to use this device uninterrupted for that length of time? *"}
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        }
                                        <Grid item xs={12}>
                                            <RadioValidatorElement
                                                falseLabel="No"
                                                trueLabel="Yes"
                                                name="ownSmartphone"
                                                value={this.state.model.ownSmartphone}
                                                question={this.props.model.enrolmentType == "1416" ? "Does your child have access to a Smartphone (Android or IPhone)? *" : "Do you have access to a Smartphone (Android or IPhone)? *"}
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        </Grid>
                                        {this.state.model.ownSmartphone &&
                                            <RadioValidatorElement
                                                falseLabel="No"
                                                trueLabel="Yes"
                                                name="ownSmartphoneCanInstallZoom"
                                                value={this.state.model.ownSmartphoneCanInstallZoom}
                                                question={this.props.model.enrolmentType == "1416" ?
                                                    "Would your child be able to install a video chat app such as Zoom on this device - Does the phone have enough space and is your child's phone still supported? *"
                                                    : "Would you be able to install a video chat app such as Zoom on this device - Do you have enough space and is your phone still supported? *"}
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        }
                                        <Grid item xs={12}>
                                            <RadioValidatorElement
                                                falseLabel="No"
                                                trueLabel="Yes"
                                                name="ownDesktop"
                                                value={this.state.model.ownDesktop}
                                                question={this.props.model.enrolmentType == "1416" ? "Does your child have access to a Desktop/Tower Computer/iMac? *" : "Do you have access to a Desktop/Tower Computer/iMac? *"}
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        </Grid>
                                        {this.state.model.ownDesktop &&
                                            <RadioValidatorElement
                                                falseLabel="No - the device is my own"
                                                trueLabel="Yes"
                                                name="ownDesktopShared"
                                                value={this.state.model.ownDesktopShared}
                                                question="Is the device a shared/family device? *"
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        }
                                        {this.props.model.enrolmentType !== "1416" && this.state.model.ownDesktopShared &&
                                            <RadioValidatorElement
                                                falseLabel="No"
                                                trueLabel="Yes"
                                                name="ownDesktopUninterrupted"
                                                value={this.state.model.ownDesktopUninterrupted}
                                                question={this.props.model.enrolmentType == "1416" ?
                                                    "A week of Online learning work can be up to 20 hours a week (4 hours a day). Will your child be able to use this device uninterrupted for that length of time? *"
                                                    : "A week of Online learning work can be up to 20 hours a week (4 hours a day). Will you be able to use this device uninterrupted for that length of time? *"}
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        }
                                        <Grid item xs={12}>
                                            <RadioValidatorElement
                                                falseLabel="No"
                                                trueLabel="Yes"
                                                name="accessToInternet"
                                                value={this.state.model.accessToInternet}
                                                question={this.props.model.enrolmentType === "1416" ?
                                                    "Does your child have an internet connection that they would be able to use for their studies? *" :
                                                    "Do you have an internet connection that you would be able to use for your studies? *"}
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        </Grid>
                                        {this.state.model.accessToInternet &&
                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="No"
                                                    trueLabel="Yes"
                                                    name="accessToInternetHomeInternet"
                                                    value={this.state.model.accessToInternetHomeInternet}
                                                    question={this.props.model.enrolmentType === "1416" ?
                                                        "Does your child have access to a home internet connection they could use their studies? *"
                                                        : "Do you have access to a home internet connection you could use for your studies? *"}
                                                    handleChange={this.handleRadioChange}
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                />
                                            </Grid>
                                        }
                                        {this.state.model.accessToInternetHomeInternet &&
                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="No"
                                                    trueLabel="Yes"
                                                    name="homeInternetDataLimit"
                                                    value={this.state.model.homeInternetDataLimit}
                                                    question="Does the home internet connection have a data limit? *"
                                                    handleChange={this.handleRadioChange}
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                />
                                            </Grid>
                                        }

                                        {this.state.model.homeInternetDataLimit &&
                                            <Grid item xs={12}>
                                                <InternetLimitDropDown
                                                    mobileInternet={false}
                                                    disabled={false}
                                                    internetLimit={this.state.model.homeInternetDataLimitValue}
                                                    setInternetLimit={this.setHomeInternetDataLimitValue}
                                                />
                                            </Grid>
                                        }
                                        {this.state.model.accessToInternet &&
                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="No"
                                                    trueLabel="Yes"
                                                    name="accessToInternetMobileInternet"
                                                    value={this.state.model.accessToInternetMobileInternet}
                                                    question={this.props.model.enrolmentType === "1416" ?
                                                        "Does your child have access to a mobile internet connection they could use their studies? *" :
                                                        "Do you have access to a mobile internet connection you could use for your studies? *"}
                                                    handleChange={this.handleRadioChange}
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                />
                                            </Grid>
                                        }
                                        {this.state.model.accessToInternetMobileInternet &&
                                            <Grid item xs={12}>
                                                <InternetLimitDropDown mobileInternet={true} disabled={false} internetLimit={this.state.model.mobileInternetDataLimitValue} setInternetLimit={this.setMobileInternetDataLimitValue} />
                                            </Grid>
                                        }
                                        <Grid item xs={12}>
                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="No"
                                                    trueLabel="Yes"
                                                    name="homeWorkingLocation"
                                                    value={this.state.model.homeWorkingLocation}
                                                    question={this.props.model.enrolmentType === "1416" ?
                                                        "Does your child have somewhere at home where you can sit comfortably and work for a number of hours each day? E.g. Desk, Dining table, Kitchen *" :
                                                        "Do you have somewhere at home where you can sit comfortably and work for a number of hours each day? E.g. Desk, Dining table, Kitchen table. *"}
                                                    handleChange={this.handleRadioChange}
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                />
                                            </Grid>
                                        </Grid>
                                        {this.state.model.homeWorkingLocation &&
                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="No"
                                                    trueLabel="Yes"
                                                    name="homeWorkingLocationQuiet"
                                                    value={this.state.model.homeWorkingLocationQuiet}
                                                    question="Is that place quiet, away from distractions? e.g. noisy family members *"
                                                    handleChange={this.handleRadioChange}
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                />
                                            </Grid>
                                        }
                                        {this.props.model.enrolmentType !== "1416" && this.state.model.homeWorkingLocationQuiet &&
                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="No"
                                                    trueLabel="Yes"
                                                    name="homeWorkingLocationOnline"
                                                    value={this.state.model.homeWorkingLocationOnline}
                                                    question="Are you able to complete online learning at that location? *"
                                                    handleChange={this.handleRadioChange}
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                />
                                            </Grid>
                                        }
                                        {this.props.model.enrolmentType !== "1416" && (this.state.model.homeWorkingLocation === false || this.state.model.homeWorkingLocation && this.state.model.homeWorkingLocationQuiet === false || (this.state.model.homeWorkingLocation && this.state.model.homeWorkingLocationQuiet && this.state.model.homeWorkingLocationOnline === false)) &&
                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="No"
                                                    trueLabel="Yes"
                                                    name="homeWorkingLocationAlternative"
                                                    value={this.state.model.homeWorkingLocationAlternative}
                                                    question="Are you able to learn elsewhere such as a friend or families house? *"
                                                    handleChange={this.handleRadioChange}
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                />
                                            </Grid>
                                        }
                                        {this.props.model.enrolmentType !== "1416" && this.state.model.homeWorkingLocationAlternative &&
                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="No"
                                                    trueLabel="Yes"
                                                    name="homeWorkingLocationAlternativeQuiet"
                                                    value={this.state.model.homeWorkingLocationAlternativeQuiet}
                                                    question="Is that place quiet, away from distractions? e.g. noisy family members *"
                                                    handleChange={this.handleRadioChange}
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                />
                                            </Grid>
                                        }
                                        {this.props.model.enrolmentType !== "1416" && this.state.model.homeWorkingLocationAlternativeQuiet &&
                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="No"
                                                    trueLabel="Yes"
                                                    name="homeWorkingLocationAlternativeOnline"
                                                    value={this.state.model.homeWorkingLocationAlternativeOnline}
                                                    question="Are you able to complete online learning at that location? *"
                                                    handleChange={this.handleRadioChange}
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                />
                                            </Grid>
                                        }
                                        {this.props.model.enrolmentType !== "1416" &&
                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="No"
                                                    trueLabel="Yes"
                                                    name="homeWorkingCareResponsibilities"
                                                    value={this.state.model.homeWorkingCareResponsibilities}
                                                    question="Do you have dependent have caring responsibilities that would reduce your ability to complete learning while working at home? *"
                                                    handleChange={this.handleRadioChange}
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                />
                                            </Grid>
                                        }
                                        {this.props.model.enrolmentType !== "1416" &&
                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="No"
                                                    trueLabel="Yes"
                                                    name="homeWorkingConcerns"
                                                    value={this.state.model.homeWorkingConcerns}
                                                    question="Do you have any other concerns about learning at home that you wish to discuss with someone from the college. If you select ‘YES’, someone from the college will contact you to discuss these concerns *"
                                                    handleChange={this.handleRadioChange}
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                />
                                            </Grid>
                                        }
                                        <Grid item xs={12}>
                                            {this.props.model.enrolmentType !== "1416" ?
                                                <Typography variant="subtitle1">
                                                    When you do need to attend College on-site, how do you intend to travel? *
                                                </Typography>
                                                :
                                                <Typography variant="subtitle1">
                                                    When your child does need to attend College on-site, how will they travel? *
                                                </Typography>
                                            }
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                label="Public Transport (Bus, Train)"
                                                control={
                                                    <Checkbox
                                                        checked={this.state.model.transportPublicTransport}
                                                        value={this.state.model.transportPublicTransport}
                                                        name="transportPublicTransport"
                                                        color="primary"
                                                        onChange={this.setTransportPublicTransport}
                                                    />
                                                }
                                                className={classes.multiSelect}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                label="Walk"
                                                control={
                                                    <Checkbox
                                                        checked={this.state.model.transportWalk}
                                                        value={this.state.model.transportWalk}
                                                        name="transportWalk"
                                                        color="primary"
                                                        onChange={this.setTransportWalk}
                                                    />
                                                }
                                                className={classes.multiSelect}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                label="Bike"
                                                control={
                                                    <Checkbox
                                                        checked={this.state.model.transportBike}
                                                        value={this.state.model.transportBike}
                                                        name="transportBike"
                                                        color="primary"
                                                        onChange={this.setTransportBike}
                                                    />
                                                }
                                                className={classes.multiSelect}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                label="Motor Bike"
                                                control={
                                                    <Checkbox
                                                        checked={this.state.model.transportMotorBike}
                                                        value={this.state.model.transportMotorBike}
                                                        name="transportMotorBike"
                                                        color="primary"
                                                        onChange={this.setTransportMotorBike}
                                                    />
                                                }
                                                className={classes.multiSelect}
                                            />
                                        </Grid>
                                        {this.props.model.enrolmentType !== "1416" &&
                                            <Grid item xs={12}>
                                                <FormControlLabel
                                                    label="Own Vehicle"
                                                    control={
                                                        <Checkbox
                                                            checked={this.state.model.transportOwnVehicle}
                                                            value={this.state.model.transportOwnVehicle}
                                                            name="transportOwnVehicle"
                                                            color="primary"
                                                            onChange={this.setTransportOwnVehicle}
                                                        />
                                                    }
                                                    className={classes.multiSelect}
                                                />
                                            </Grid>
                                        }
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                label={this.props.model.enrolmentType === "1416" ? "Car" : "Car Share (friend or family members)"}
                                                control={
                                                    <Checkbox
                                                        checked={this.state.model.transportCarShare}
                                                        value={this.state.model.transportCarShare}
                                                        name="transportCarShare"
                                                        color="primary"
                                                        onChange={this.setTransportCarShare}
                                                    />
                                                }
                                                className={classes.multiSelect}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle1">
                                                While we do not need to know about medical conditions or any extra details, it would be helpful to know if either {this.props.model.enrolmentType === "1416" ? "your child or someone in their" : "you or someone in your"}  family is classed as High Risk or was Shielding under the Governments COVID-19 higher risk categories.
                                            </Typography>

                                            <RadioValidatorElement
                                                falseLabel="No"
                                                trueLabel="Yes"
                                                name="covidHighRisk"
                                                value={this.state.model.covidHighRisk}
                                                question={this.props.model.enrolmentType === "1416" ? "Is your child classed as a high risk/vulnerable person for COVID-19? *" : "Are you classed as a high risk/vulnerable person for COVID-19? *"}
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <RadioValidatorElement
                                                falseLabel="No"
                                                trueLabel="Yes"
                                                name="covidHighRiskFamily"
                                                value={this.state.model.covidHighRiskFamily}
                                                question={this.props.model.enrolmentType === "1416" ? "Does your child live with someone classed as high risk for COVID-19? This includes older people, someone with health conditions and pregnant women *" : "Do you live with or have caring responsibilities for someone classed as high risk for COVID-19, this includes older people, someone with health conditions and pregnant women? *"}
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        </Grid>
                                    </Grid>
                                    <hr />
                                    <Grid spacing={1} className={classes.root} container style={{ marginTop: '20px', marginBottom: '20px' }}>
                                        <Grid item xs={12}>
                                            <Typography variant="h4">
                                                Photo
                                            </Typography>
                                            {(navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) == false ?
                                                this.props.model.enrolmentType !== "1416" ?
                                                    <Typography variant="subtitle1">
                                                        You now have the opportunity to upload a photo, this will be used on your student ID card, and within the student systems.
                                                </Typography>
                                                    :
                                                    <Typography variant="subtitle1">
                                                        You now have the opportunity to upload a photo of your child, this will be used on their student ID card, and within the student systems.
                                                    </Typography>
                                                :
                                                <Typography variant="subtitle1">
                                                    You will be asked to take a photo at college.
                                                </Typography>
                                            }
                                        </Grid>
                                        {(navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) == false &&
                                            <React.Fragment>
                                                <Grid item xs={12}>
                                                    <EnrolmentPhotoCapture setPhoto={this.setPhoto} photo={this.state.model.photo} />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="I disagree"
                                                        trueLabel="I agree"
                                                        name="photoConditionsAccepted"
                                                        value={this.state.model.photoConditionsAccepted}
                                                        question={this.props.model.enrolmentType !== "1416" ? "Having uploaded your own photo, you agree that it meets the college student photo criteria, and understand that if it does not, a suitable replacement photo will be required. *"
                                                            : "Having uploaded your child's photo, you agree that it meets the college student photo criteria, and understand that if it does not, a suitable replacement photo will be required. *"}
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>

                                                {this.state.model.photoConditionsAccepted === false &&
                                                    <Grid item xs={12}>
                                                        <Typography>All students are required to meet the College student photo criteria, please either ensure that your photo meets the criteria and select Yes. If you do not agree your photo will not be attached and your photo will be taken at a later date.</Typography>
                                                    </Grid>
                                                }
                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="I disagree"
                                                        trueLabel="I agree"
                                                        name="photoMarketingPurposes"
                                                        value={this.state.model.photoMarketingPurposes}
                                                        question="Would you allow your photo to be used in college for other uses such as marketing as well as on your college ID card? *"
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>
                                            </React.Fragment>
                                        }
                                    </Grid>

                                    <Grid spacing={1} className={classes.root} container style={{ marginTop: '20px' }}>
                                        <Grid item xs={12}>
                                            <Typography variant="h4">
                                                Data Protection & GDPR
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle1">
                                                All students need to read the Education Skills Funding Agency (ESFA) Privacy Notice. The Privacy Notice is available <a target="_blank" onClick={this.handlePrivacyNoticeClick} href="https://www.gov.uk/government/publications/esfa-privacy-notice/education-and-skills-funding-agency-privacy-notice-may-2018">at this link</a>.
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            {this.state.privacyNoticeRead !== true ?
                                                <FakeRadioValidatorElement
                                                    falseLabel="I disagree"
                                                    trueLabel="I agree"
                                                    name="privacyNoticeAccepted"
                                                    value={this.state.model.privacyNoticeAccepted}
                                                    question="Please confirm that you have read and reviewed the ESFA Privacy notice, and that you agree to the specified conditions *"
                                                    handleChange={this.handlePrivacyNoticeRadioChange}
                                                    validators={['required', 'isBoolTrue']}
                                                    errorMessages={['This field is required', 'You must agree to contiue']}
                                                    readOnly="true"
                                                />
                                                :
                                                <RadioValidatorElement
                                                    falseLabel="I disagree"
                                                    trueLabel="I agree"
                                                    name="privacyNoticeAccepted"
                                                    value={this.state.model.privacyNoticeAccepted}
                                                    question="Please confirm that you have read and reviewed the ESFA Privacy notice, and that you agree to the specified conditions *"
                                                    handleChange={this.handleRadioChange}
                                                    validators={['required', 'isBoolTrue']}
                                                    errorMessages={['This field is required', 'You must agree to contiue']}
                                                />
                                            }
                                            {this.state.privacyNoticeRead === false &&
                                                <Alert severity="error" style={{ whiteSpace: "pre-line" }}>Please read the privacy notice first.</Alert>
                                            }
                                        </Grid>
                                        {this.props.model.enrolmentType !== "1416" &&
                                            <React.Fragment>
                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="allowESALearningOpportunities"
                                                        value={this.state.model.allowESALearningOpportunities}
                                                        question="Please confirm if the ESFA can contact you regarding courses and learning opportunities *"
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="allowESAResearch"
                                                        value={this.state.model.allowESAResearch}
                                                        question="Please confirm if the ESFA can contact you regarding surveys and research *"
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>
                                            </React.Fragment>
                                        }
                                        {(this.state.model.allowESALearningOpportunities || this.state.model.allowESAResearch) &&
                                            <React.Fragment>
                                                <Grid item xs={12}>
                                                    <Typography variant="subtitle1">
                                                        Please select the method by which the ESFA can contact you:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="allowESAContactByPost"
                                                        value={this.state.model.allowESAContactByPost}
                                                        question="By post"
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="allowESAContactByTelephone"
                                                        value={this.state.model.allowESAContactByTelephone}
                                                        question="By phone"
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="allowESAContactByEmail"
                                                        value={this.state.model.allowESAContactByEmail}
                                                        question="By email"
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>
                                            </React.Fragment>
                                        }
                                        <Grid item xs={12}>
                                            <RadioValidatorElement
                                                falseLabel="Opt out"
                                                trueLabel="Opt in"
                                                name="lrsAccepted"
                                                value={this.state.model.lrsAccepted}
                                                question="The Learner Records Service (LRS) provides a central record of all your qualifications and grades via a Unique Learner Number (ULN), and this can be accessed by all institutions across the country on your behalf to obtain proof of your achievements (particularly useful if you lose copies of your certificates). We encourage you to opt in to allowing the college to share your personal data with the Learner Record Service (LRS) so that you don’t later restrict progression opportunities with other institutions. *"
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <RadioValidatorElement
                                                falseLabel="No"
                                                trueLabel="Yes"
                                                name="allowMarketing"
                                                value={this.state.model.allowMarketing}
                                                question="From time to time we would like to be able to update you about  other courses that the College is running. Would you be interested in being contacted by Hull College about these courses. *"
                                                handleChange={this.handleRadioChange}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        </Grid>
                                        {this.state.model.allowMarketing &&
                                            <React.Fragment>
                                                <Grid item xs={12}>
                                                    <Typography variant="subtitle1">
                                                        Please select the method by which we can contact you:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="allowSocialMedia"
                                                        value={this.state.model.allowSocialMedia}
                                                        question="By Social Media"
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="allowPhone"
                                                        value={this.state.model.allowPhone}
                                                        question="By Phone"
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="allowPost"
                                                        value={this.state.model.allowPost}
                                                        question="By Post"
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="allowEmail"
                                                        value={this.state.model.allowEmail}
                                                        question="By Email"
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required']}
                                                        errorMessages={['This field is required']}
                                                    />
                                                </Grid>
                                            </React.Fragment>
                                        }
                                    </Grid>

                                    {this.props.model.enrolmentType !== "1416" &&
                                        <React.Fragment>
                                            <Grid spacing={1} className={classes.root} container style={{ marginTop: '20px' }}>
                                                <Grid item xs={12}>
                                                    <Typography variant="h4">
                                                        Enrolment Confirmation
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <RadioValidatorElement
                                                        falseLabel="No"
                                                        trueLabel="Yes"
                                                        name="enrolmentConfirmed"
                                                        value={this.state.model.enrolmentConfirmed}
                                                        question="Please confirm you're happy with the details entered and wish to complete your enrolment form *"
                                                        handleChange={this.handleRadioChange}
                                                        validators={['required', 'isBoolTrue']}
                                                        errorMessages={['This field is required', 'You must agree to continue']}
                                                    />
                                                </Grid>
                                                {this.state.model.enrolmentConfirmed &&
                                                    <React.Fragment>
                                                        <Grid item xs={12}>
                                                            <Typography variant="subtitle1">
                                                                Please enter your first and last name to confirm your details
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <FormControl fullWidth>
                                                                <TextValidator
                                                                    label="First Name *"
                                                                    name="enrolmentConfirmedFirstName"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    margin="normal"
                                                                    value={this.state.model.enrolmentConfirmedFirstName}
                                                                    onChange={this.handleChange}
                                                                    validators={['isFirstForenameValid', 'required']}
                                                                    errorMessages={['First Name should be between 2 and 40 characters, and contain letters and hyphens only', 'This field is required']}
                                                                />
                                                            </FormControl>
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <FormControl fullWidth>
                                                                <TextValidator
                                                                    label="Surname *"
                                                                    name="enrolmentConfirmedLastName"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    margin="normal"
                                                                    value={this.state.model.enrolmentConfirmedLastName}
                                                                    onChange={this.handleChange}
                                                                    validators={['isSurnameValid', 'required']}
                                                                    errorMessages={['Surname should not exceed 30 characters, and contain letters, hyphens and spaces only', 'This field is required']}
                                                                />
                                                            </FormControl>
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <Typography variant="subtitle1">
                                                                Please provide a signature to confirm your enrolment:
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <SignatureCanvas ref={(ref) => { this.signatureRef = ref }} onEnd={this.setSignature} backgroundColor={'#FFFFFF'} canvasProps={{
                                                                style: { borderWidth: '1px', borderColor: '#c1c1c1', borderStyle: 'solid', borderRadius: '4px', height: '200px', maxHeight: '200px', width: '100%' }
                                                            }} />
                                                        </Grid>
                                                        <Grid item xs={12} sm={4}>
                                                            <Button onClick={this.clearSignature} color="primary" variant="contained" fullWidth style={{ marginTop: "15px" }} endIcon={<DeleteForever />}>
                                                                Clear Signature
                                                            </Button>
                                                        </Grid>
                                                    </React.Fragment>
                                                }
                                            </Grid>
                                        </React.Fragment>
                                    }

                                    {this.props.model.enrolmentType === "1416" &&
                                        <Grid spacing={1} className={classes.root} container style={{ marginTop: '20px' }}>
                                            <Grid item xs={12}>
                                                <Typography variant="h4">
                                                    Parent Enrolment Confirmation
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Typography variant="subtitle1">
                                                    Privacy Notice
                                                </Typography>
                                                <Typography variant="subtitle1">
                                                    The College endeavours to be as transparent about the processing of individual’s personal data as it can be, and a copy of the full ‘Privacy Notice for Parents of children under 16’ should have been provided alongside this form. An electronic copy of this Privacy Notice and the Full Data Protection (GDPR) Policy can be accessed on the college website. The Privacy notice sets out the purpose for collecting the information, your rights in relation to the information we have collected from you, how we protect your information and the learner’s information, and who we share your information with.
                                                </Typography>
                                                <Typography variant="subtitle1">
                                                    By signing this enrolment form I confirm the following:
                                                </Typography>
                                                <ul>
                                                    <li>I have received a copy of the ‘Privacy Notice for Parents of children under 16’ and understand how the college will process the information I have provided. I also understand the personal information of the learner will be shared with third parties, such as the Department for Education (DfE), but only for the purposes of their learning programme.</li>
                                                    <li>I declare that all the information I have provided on the learner’s behalf is accurate.</li>
                                                    <li>I give the College permission to view the learner’s personal learning record and access any previous achievements they may have already received.</li>
                                                    <li>I confirm that the learner will not be studying at any other school, college or training provider, at the start of their course.</li>
                                                    <li>I accept that the personal details given on this learning agreement will be shown on any documentation or certificates for the learner, and I am aware I may incur a charge for any subsequent certificate changes.</li>
                                                    <li>I understand that at enrolment the learner will receive their own ‘Privacy Notice for Learners’ so they are fully informed about how we process their information, and they will receive their own learning agreement to confirm their information is correct and that they are enrolled to the correct study programme.</li>
                                                    <li>I agree to support the 14-16 College by encouraging my child to attend regularly, on time and properly equipped and will inform the 14-16 College of any absence.</li>
                                                    <li>I agree to support the 14-16 College on its policies of attendance, uniform and behaviour.</li>
                                                    <li>I agree to support KS4 learning structure by not taking my child out for holidays in term time.</li>
                                                    <li>I agree to make the 14-16 College aware of any concerns which may affect my child’s behaviour.</li>
                                                    <li>I agree that the 14-16 College has a responsibility to contact help from outside agencies if my child is causing concern of a learning, behavioural or medical nature.</li>
                                                    <li>I agree that services and agencies can be accessed by my child to help support their learning and wellbeing. College services such as Counselling, which can be accessed face to face, online or by phone, as well as behaviour mentor support is part of the College offer.</li>
                                                    <li>I agree to support my child with homework.</li>
                                                    <li>I am aware and agree that my child may be transported to other Hull College Group sites when required for studies.</li>
                                                    <li>I am aware that my child may not be supervised during lunch and break times.</li>
                                                    <li>I am aware that on occasion my child may be taken on a local visit, away from the school to enhance their learning. If the visit is out of the area or of a hazardous nature the 14-16 College will provide details and seek my permission before the trip.</li>
                                                    <li>I am aware that if my child causes any kind of damage to college property or displays unacceptable behaviour which is classed at ‘Gross-Misconduct’ a meeting to discuss placement will be set up for all involved. I also understand the College has a security team to support and protect learners and the college community.</li>
                                                    <li>I have read the parent/student handbook and understand the college/security presence and the policy and procedures which may be used to protect my child.</li>
                                                    <li>I agree that my child should receive professional medical help in an emergency if I cannot be contacted.</li>
                                                </ul>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <RadioValidatorElement
                                                    falseLabel="No"
                                                    trueLabel="Yes"
                                                    name="enrolmentParentConfirmed"
                                                    value={this.state.model.enrolmentParentConfirmed}
                                                    question="Please tick the box to confirm you are happy with the details entered and wish to complete your child's enrolment form *"
                                                    handleChange={this.handleRadioChange}
                                                    validators={['required', 'isBoolTrue']}
                                                    errorMessages={['This field is required', 'You must agree to continue']}
                                                />
                                            </Grid>
                                            {this.state.model.enrolmentParentConfirmed &&
                                                <React.Fragment>
                                                    <Grid item xs={12}>
                                                        <Typography variant="subtitle1">
                                                            Please enter your first and last name to confirm your details, and select your relationship to the child being enrolled.
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <FormControl fullWidth>
                                                            <TextValidator
                                                                label="First Name *"
                                                                name="enrolmentParentConfirmedFirstName"
                                                                fullWidth
                                                                variant="outlined"
                                                                margin="normal"
                                                                value={this.state.model.enrolmentParentConfirmedFirstName}
                                                                onChange={this.handleChange}
                                                                validators={['isFirstForenameValid', 'required']}
                                                                errorMessages={['First Name should be between 2 and 40 characters, and contain letters and hyphens only', 'This field is required']}
                                                            />
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <FormControl fullWidth>
                                                            <TextValidator
                                                                label="Surname *"
                                                                name="enrolmentParentConfirmedLastName"
                                                                fullWidth
                                                                variant="outlined"
                                                                margin="normal"
                                                                value={this.state.model.enrolmentParentConfirmedLastName}
                                                                onChange={this.handleChange}
                                                                validators={['isSurnameValid', 'required']}
                                                                errorMessages={['Surname should not exceed 30 characters, and contain letters, hyphens and spaces only', 'This field is required']}
                                                            />
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <StudentRelationshipDropDown required={true} enrolmentConfirmationMode={true} childMode={this.props.model.enrolmentType === "1416"} label="Relationship to child *" disabled={false} propName="enrolmentParentConfirmedRelationship" studentRelationship={this.state.model.enrolmentParentConfirmedRelationship} setStudentRelationship={this.setEnrolmentParentConfirmedRelationship} />
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <Typography variant="subtitle1">
                                                            Please provide a signature to confirm your child's enrolment:
                                                </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <SignatureCanvas ref={(ref) => { this.signatureParentRef = ref }} onEnd={this.setParentSignature} backgroundColor={'#FFFFFF'} canvasProps={{
                                                            style: { borderWidth: '1px', borderColor: '#c1c1c1', borderStyle: 'solid', borderRadius: '4px', height: '200px', maxHeight: '200px', width: '100%' }
                                                        }} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}>
                                                        <Button onClick={this.clearParentSignature} color="primary" variant="contained" fullWidth style={{ marginTop: "15px" }} endIcon={<DeleteForever />}>
                                                            Clear Signature
                                                </Button>
                                                    </Grid>
                                                </React.Fragment>
                                            }
                                        </Grid>
                                    }

                                    <Grid item container justify="flex-end" spacing={2}>
                                        {this.state.formInvalid &&
                                            <Grid item xs={12}>
                                                <Alert severity="error" style={{ whiteSpace: "pre-line" }}>Incomplete fields have been highlighted red. Please complete these sections to continue.</Alert>
                                            </Grid>
                                        }
                                        {this.state.disailityInvalid &&
                                            <Grid item xs={12}>
                                                <Alert severity="error" style={{ whiteSpace: "pre-line" }}>You have specified that {this.props.model.enrolmentType === "1416" ? "your child" : "you"} have a disability/learning difficulty/health problem, but have not specified which. Please ammend to continue.</Alert>
                                            </Grid>
                                        }
                                        <Grid item xs={12} sm={5} md={5} className={classes.buttonItem}>
                                            <Button type="submit" color="primary" variant="contained" className={classes.button} endIcon={<ArrowForward />} fullWidth>
                                                Confirm Enrolment
                                                {this.state.saving && <CircularProgress color='secondary' size={24} className={this.props.classes.buttonProgress} />}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </ValidatorForm>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </React.Fragment >
        );
    }

    private handlePrivacyNoticeClick = () => {
        this.setState({ privacyNoticeRead: true, showPrivacyNoticeNote: false });
    }

    private handleRadioChange = (event) => {
        let newModel = this.state.model;
        newModel[event.target.name] = (event.target.value === "true" ? true : false);
        this.setState({ model: newModel });
    }

    private handlePrivacyNoticeRadioChange = (event) => {
        event.preventDefault();
        this.setState({ showPrivacyNoticeNote: true });
    }

    private handleDiffrentTermTimeAddressChange = (event) => {

        this.setState({ termTimeAddressDifferent: (event.target.value === "true" ? true : false) });
    }

    private setPrimaryAddress = (address: AddressSelectorViewModel) => {
        let newModel = this.state.model;
        newModel.addressIndex = address.addressIndex;
        newModel.address1 = address.address1;
        newModel.address2 = address.address2;
        newModel.address3 = address.address3;
        newModel.address4 = address.address4;
        newModel.postcode = address.postcode;
        if (address.postcode !== undefined) {
            if (address.postcode!.split(' ')[0] !== undefined) {
                newModel.postcodeOut = address.postcode!.split(' ')[0]!.toUpperCase();
            }
            if (address.postcode!.split(' ')[1] !== undefined) {
                newModel.postcodeIn = address.postcode!.split(' ')[1]!.toUpperCase();
            }
        }

        this.setState({ model: newModel });
    }

    private setParent1Address = (address: AddressSelectorViewModel) => {
        let newModel = this.state.model;
        newModel.parent1AddressIndex = address.addressIndex;
        newModel.parent1Address1 = address.address1;
        newModel.parent1Address2 = address.address2;
        newModel.parent1Address3 = address.address3;
        newModel.parent1Address4 = address.address4;
        newModel.parent1Postcode = address.postcode;

        this.setState({ model: newModel });
    }

    private setParent2Address = (address: AddressSelectorViewModel) => {
        let newModel = this.state.model;
        newModel.parent2AddressIndex = address.addressIndex;
        newModel.parent2Address1 = address.address1;
        newModel.parent2Address2 = address.address2;
        newModel.parent2Address3 = address.address3;
        newModel.parent2Address4 = address.address4;
        newModel.parent2Postcode = address.postcode;

        this.setState({ model: newModel });
    }

    private setTermTimeAddress = (address: AddressSelectorViewModel) => {
        let newModel = this.state.model;
        newModel.termTimeAddressIndex = address.addressIndex;
        newModel.termTimeAddress1 = address.address1;
        newModel.termTimeAddress2 = address.address2;
        newModel.termTimeAddress3 = address.address3;
        newModel.termTimeAddress4 = address.address4;
        newModel.termTimePostcode = address.postcode;
        if (address.postcode !== undefined) {
            if (address.postcode!.split(' ')[0] !== undefined) {
                newModel.termTimePostcodeOut = address.postcode!.split(' ')[0]!.toUpperCase();
            }
            if (address.postcode!.split(' ')[1] !== undefined) {
                newModel.termTimePostcodeIn = address.postcode!.split(' ')[1]!.toUpperCase();
            }
        }

        this.setState({ model: newModel });
    }

    private clearSignature = () => {
        this.signatureRef.clear();
        let newModel = this.state.model;
        newModel.signature = '';
        this.setState({ model: newModel });
    }

    private setSignature = () => {
        let newModel = this.state.model;
        newModel.signature = this.signatureRef.toDataURL('image/png');
        this.setState({ model: newModel });
    }

    private clearParentSignature = () => {
        this.signatureParentRef.clear();
        let newModel = this.state.model;
        newModel.signatureParent = '';
        this.setState({ model: newModel });
    }

    private setParentSignature = () => {
        let newModel = this.state.model;
        newModel.signatureParent = this.signatureParentRef.toDataURL('image/png');
        this.setState({ model: newModel });
    }

    private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const currModel: EnrolmentFormViewModel = this.state.model;
        currModel[event.target.name] = event.target.value;

        this.setState({ model: currModel });
    }

    private handleDateChange = (key, date) => {
        if (date !== null && date !== undefined && this.state.model[key] !== date) {

            const currModel: EnrolmentFormViewModel = this.state.model;
            currModel[key] = date;

            this.setState({ model: currModel });
        }
    };

    public setSex = (event) => {
        if (this.state.model.sex !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.sex = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setPriorAttianment = (event) => {
        if (this.state.model.priorAttainment !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.priorAttainment = event.target.value;

            this.setState({
                model: newModel
            });
        }
    }

    public setSchool = (event) => {
        if (this.state.model.school !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.school = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setOccupation = (event) => {
        if (this.state.model.occupation !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.occupation = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setNationality = (event) => {
        if (this.state.model.nationality !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.nationality = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setCountry = (event) => {
        if (this.state.model.country !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.country = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setEthnicGroup = (event) => {
        if (this.state.model.ethnicOrigin !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.ethnicOrigin = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setLearningDifficultyResponse = (event) => {
        if (this.state.model.learningDifficultyDisabilityResponse !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.learningDifficultyDisabilityResponse = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setEmploymentStatus = (event) => {
        if (this.state.model.employmentStatus !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.employmentStatus = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setEmploymentIntensity = (event) => {
        if (this.state.model.employmentIntensity !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.employmentIntensity = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setBenifitStatus = (event) => {
        if (this.state.model.benifitsStatus !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.benifitsStatus = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setEmploymentLength = (event) => {
        if (this.state.model.employmentLength !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.employmentLength = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setUnemploymentLength = (event) => {
        if (this.state.model.unemploymentLength !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.unemploymentLength = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setDisabilities = (newModel: DisabilitySelectionViewModel[]) => {
        if (this.state.model.disabilitySelection !== newModel) {
            let newEnrolModel: EnrolmentFormViewModel = this.state.model;
            newEnrolModel.disabilitySelection = newModel
            this.setState({ model: newEnrolModel });
        }
    }

    public handleHouseholdSituationChange = (event) => {
        if ((event.target.value === "1,3" && (this.state.model.householdSituation !== "1" || this.state.model.householdSituation2 !== "3")) ||
            event.target.value !== "1,3" && (this.state.model.householdSituation !== event.target.value || this.state.model.householdSituation2 !== undefined)) {
            let newModel: EnrolmentFormViewModel = this.state.model;

            if (event.target.value === "1,3") {
                newModel.householdSituation = "1";
                newModel.householdSituation2 = "3";
            } else {
                newModel.householdSituation = event.target.value;
                newModel.householdSituation2 = undefined;
            }


            this.setState({ model: newModel });
        }
    }

    public handleFeesAndFundingSourceChange = (event) => {
        console.log(1);
        console.log(event);
        console.log(this.state.model.feesAndFundingSource);
        if (this.state.model.feesAndFundingSource !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.feesAndFundingSource = event.target.value;

            this.setState({ model: newModel }, () => {
                console.log(2);
                console.log(event);
                console.log(this.state.model.feesAndFundingSource);
            });
        }
    }

    public handleFeesAndFundingChange = (event) => {
        if (this.state.model.feesAndFunding !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.feesAndFunding = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setFirstLanguage = (event) => {
        if (this.state.model.firstLanguage !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.firstLanguage = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setHEQuals = (event) => {
        if (this.state.model.heQuals !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.heQuals = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setParent1Title = (event) => {
        if (this.state.model.parent1Title !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.parent1Title = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setParent2Title = (event) => {
        if (this.state.model.parent2Title !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.parent2Title = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setTitle = (event) => {
        if (this.state.model.title !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.title = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setAccommodationType = (event) => {
        if (this.state.model.accommodationType !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.accommodationType = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setEnrolmentParentConfirmedRelationship = (event) => {
        if (this.state.model.enrolmentParentConfirmedRelationship !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.enrolmentParentConfirmedRelationship = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setStudentRelationship = (event) => {
        if (this.state.model.contactRelationship !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.contactRelationship = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setParentContactRelationship = (event) => {
        if (this.state.model.parentContactRelationship !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.parentContactRelationship = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setParent2ContactRelationship = (event) => {
        if (this.state.model.parent2ContactRelationship !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.parent2ContactRelationship = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setEnglishGrade = (value, askYear11) => {
        if (this.state.model.gcseEnglishGrade !== value) {
            let newModel: EnrolmentFormViewModel = this.state.model;

            console.log(askYear11);
            newModel.gcseEnglishGrade = value;
            newModel.englishFSQuestion = undefined;
            newModel.gcseEnglishGradeAskLevel2 = askYear11;
            newModel.englishByEndOfYear11 = undefined;

            this.setState({ model: newModel });
        }
    }

    public setEnglishFSQuestion = (val: boolean) => {
        if (this.state.model.englishFSQuestion !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.englishFSQuestion = val;

            this.setState({ model: newModel });
        }
    }

    public setEnglishByEndOfYear11 = (val: boolean) => {
        if (this.state.model.englishByEndOfYear11 !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.englishByEndOfYear11 = val;

            this.setState({ model: newModel });
        }
    }

    public setAlsRequested = (val: boolean) => {
        if (this.state.model.alsRequested !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.alsRequested = val;

            this.setState({ model: newModel });
        }
    }

    public setHasEHCP = (val: boolean) => {
        if (this.state.model.hasEHCP !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.hasEHCP = val;

            this.setState({ model: newModel });
        }
    }

    public setEnglishLitGrade = (value, askYear11) => {
        if (this.state.model.gcseEnglishLitGrade !== value) {
            let newModel: EnrolmentFormViewModel = this.state.model;

            newModel.gcseEnglishLitGrade = value;
            newModel.englishLitFSQuestion = undefined;
            newModel.gcseEnglishLitGradeAskLevel2 = askYear11;
            newModel.englishLitByEndOfYear11 = undefined;

            this.setState({ model: newModel });
        }
    }

    public setEnglishLitFSQuestion = (val: boolean) => {
        if (this.state.model.englishLitFSQuestion !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.englishLitFSQuestion = val;

            this.setState({ model: newModel });
        }
    }

    public setEnglishLitByEndOfYear11 = (val: boolean) => {
        if (this.state.model.englishLitByEndOfYear11 !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.englishLitByEndOfYear11 = val;

            this.setState({ model: newModel });
        }
    }

    public setMathsGrade = (value, askYear11) => {
        if (this.state.model.gcseMathsGrade !== value) {
            let newModel: EnrolmentFormViewModel = this.state.model;

            newModel.gcseMathsGrade = value;
            newModel.mathsFSQuestion = undefined;
            newModel.gcseMathsGradeAskLevel2 = askYear11;
            newModel.mathsByEndOfYear11 = undefined;

            this.setState({ model: newModel });
        }
    }


    public setMathsFSQuestion = (val: boolean) => {
        if (this.state.model.mathsFSQuestion !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.mathsFSQuestion = val;

            this.setState({ model: newModel });
        }
    }

    public setMathsByEndOfYear11 = (val: boolean) => {
        if (this.state.model.mathsByEndOfYear11 !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.mathsByEndOfYear11 = val;

            this.setState({ model: newModel });
        }
    }

    public setPreviousExamConcessions = (val: boolean) => {
        if (this.state.model.previousExamConcessions !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.previousExamConcessions = val;

            this.setState({ model: newModel });
        }
    }

    public setEuroResident = (val: boolean) => {
        if (this.state.model.euroResident !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.euroResident = val;

            this.setState({ model: newModel });
        }
    }

    public setArmedForces = (val: boolean) => {
        if (this.state.model.armedForces !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.armedForces = val;

            this.setState({ model: newModel });
        }
    }

    public setLocalAuthorityCare = (val: boolean) => {
        if (this.state.model.localAuthorityCare !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.localAuthorityCare = val;

            this.setState({ model: newModel });
        }
    }

    public setCareLeaver = (val: boolean) => {
        if (this.state.model.careLeaver !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.careLeaver = val;

            this.setState({ model: newModel });
        }
    }

    public setYoungCarer = (val: boolean) => {
        if (this.state.model.youngCarer !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.youngCarer = val;

            this.setState({ model: newModel });
        }
    }

    public setFreeSchoolMeals = (val: boolean) => {
        if (this.state.model.freeSchoolMeals !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.freeSchoolMeals = val;

            this.setState({ model: newModel });
        }
    }

    public setPreviousFreeSchoolMeals = (val: boolean) => {
        if (this.state.model.previousFreeSchoolMeals !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.previousFreeSchoolMeals = val;

            this.setState({ model: newModel });
        }
    }

    public setPhotoPermission1416 = (val: boolean) => {
        if (this.state.model.photoPermission1416 !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.photoPermission1416 = val;

            this.setState({ model: newModel });
        }
    }

    public setSelfEmployed = (val: boolean) => {
        if (this.state.model.isSelfEmployed !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.isSelfEmployed = val;

            this.setState({ model: newModel });
        }
    }

    public setFullTimeEducation = (val: boolean) => {
        if (this.state.model.fullTimeEducation !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.fullTimeEducation = val;

            this.setState({ model: newModel });
        }
    }

    public setCcriminalConviction = (val: boolean) => {
        if (this.state.model.criminalConviction !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.criminalConviction = val;

            this.setState({ model: newModel });
        }
    }

    public setOwnTablet = (val: boolean) => {
        if (this.state.model.ownTablet !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.ownTablet = val;

            this.setState({ model: newModel });
        }
    }

    public setOwnTabletShared = (val: boolean) => {
        if (this.state.model.ownTabletShared !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.ownTabletShared = val;

            this.setState({ model: newModel });
        }
    }

    public setOwnTabletUninterrupted = (val: boolean) => {
        if (this.state.model.ownTabletUninterrupted !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.ownTabletUninterrupted = val;

            this.setState({ model: newModel });
        }
    }

    public setOwnLaptop = (val: boolean) => {
        if (this.state.model.ownLaptop !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.ownLaptop = val;

            this.setState({ model: newModel });
        }
    }

    public setOwnLaptopShared = (val: boolean) => {
        if (this.state.model.ownLaptopShared !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.ownLaptopShared = val;

            this.setState({ model: newModel });
        }
    }

    public setOwnLaptopUninterrupted = (val: boolean) => {
        if (this.state.model.ownLaptopUninterrupted !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.ownLaptopUninterrupted = val;

            this.setState({ model: newModel });
        }
    }

    public setOwnSmartphone = (val: boolean) => {
        if (this.state.model.ownSmartphone !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.ownSmartphone = val;

            this.setState({ model: newModel });
        }
    }

    public setOwnSmartphoneCanInstallZoom = (val: boolean) => {
        if (this.state.model.ownSmartphoneCanInstallZoom !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.ownSmartphoneCanInstallZoom = val;

            this.setState({ model: newModel });
        }
    }

    public setOwnDesktop = (val: boolean) => {
        if (this.state.model.ownDesktop !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.ownDesktop = val;

            this.setState({ model: newModel });
        }
    }

    public setOwnDesktopShared = (val: boolean) => {
        if (this.state.model.ownDesktopShared !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.ownDesktopShared = val;

            this.setState({ model: newModel });
        }
    }

    public setOwnDesktopUninterrupted = (val: boolean) => {
        if (this.state.model.ownDesktopUninterrupted !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.ownDesktopUninterrupted = val;

            this.setState({ model: newModel });
        }
    }

    public setAccessToInternet = (val: boolean) => {
        if (this.state.model.accessToInternet !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.accessToInternet = val;

            newModel.accessToInternetHomeInternet = undefined;
            newModel.accessToInternetMobileInternet = undefined;

            this.setState({ model: newModel });
        }
    }

    public setAccessToInternetHome = (val: boolean) => {
        if (this.state.model.accessToInternetHomeInternet !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.accessToInternetHomeInternet = val;

            this.setState({ model: newModel });
        }
    }

    public setAccessToInternetMobile = (val: boolean) => {
        if (this.state.model.accessToInternetMobileInternet !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.accessToInternetMobileInternet = val;

            this.setState({ model: newModel });
        }
    }

    public setHomeInternetDataLimit = (val: boolean | undefined) => {
        if (this.state.model.homeInternetDataLimit !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.homeInternetDataLimit = val;

            this.setState({ model: newModel });
        }
    }

    public setHomeWorkingLocation = (val: boolean | undefined) => {
        if (this.state.model.homeWorkingLocation !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.homeWorkingLocation = val;
            newModel.homeWorkingLocationAlternative = undefined;
            newModel.homeWorkingLocationAlternativeQuiet = undefined;
            newModel.homeWorkingLocationAlternativeOnline = undefined;
            newModel.homeWorkingLocationQuiet = undefined;
            newModel.homeWorkingLocationOnline = undefined;

            this.setState({ model: newModel });
        }
    }

    public setHomeWorkingLocationQuiet = (val: boolean | undefined) => {
        if (this.state.model.homeWorkingLocationQuiet !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.homeWorkingLocationQuiet = val;
            newModel.homeWorkingLocationAlternative = undefined;
            newModel.homeWorkingLocationAlternativeQuiet = undefined;
            newModel.homeWorkingLocationAlternativeOnline = undefined;
            newModel.homeWorkingLocationOnline = undefined;

            this.setState({ model: newModel });
        }
    }

    public setHomeWorkingLocationOnline = (val: boolean | undefined) => {
        if (this.state.model.homeWorkingLocationOnline !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.homeWorkingLocationOnline = val;

            newModel.homeWorkingLocationAlternative = undefined;
            newModel.homeWorkingLocationAlternativeQuiet = undefined;
            newModel.homeWorkingLocationAlternativeOnline = undefined;

            this.setState({ model: newModel });
        }
    }

    public setHomeWorkingLocationAlternative = (val: boolean | undefined) => {
        if (this.state.model.homeWorkingLocationAlternative !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.homeWorkingLocationAlternative = val;

            newModel.homeWorkingLocationAlternativeQuiet = undefined;
            newModel.homeWorkingLocationAlternativeOnline = undefined;

            this.setState({ model: newModel });
        }
    }

    public setHomeWorkingLocationAlternativeQuiet = (val: boolean | undefined) => {
        if (this.state.model.homeWorkingLocationAlternativeQuiet !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.homeWorkingLocationAlternativeQuiet = val;

            newModel.homeWorkingLocationAlternativeOnline = undefined;

            this.setState({ model: newModel });
        }
    }

    public setHomeWorkingLocationAlternativeOnline = (val: boolean | undefined) => {
        if (this.state.model.homeWorkingLocationAlternativeOnline !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.homeWorkingLocationAlternativeOnline = val;

            this.setState({ model: newModel });
        }
    }

    public setHomeWorkingCareResponsibilities = (val: boolean | undefined) => {
        if (this.state.model.homeWorkingCareResponsibilities !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.homeWorkingCareResponsibilities = val;

            this.setState({ model: newModel });
        }
    }

    public setHomeWorkingConcerns = (val: boolean | undefined) => {
        if (this.state.model.homeWorkingConcerns !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.homeWorkingConcerns = val;

            this.setState({ model: newModel });
        }
    }

    public setCovidHighRisk = (val: boolean | undefined) => {
        if (this.state.model.covidHighRisk !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.covidHighRisk = val;

            this.setState({ model: newModel });
        }
    }

    public setCovidHighRiskFamily = (val: boolean | undefined) => {
        if (this.state.model.covidHighRiskFamily !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.covidHighRiskFamily = val;

            this.setState({ model: newModel });
        }
    }

    public setPhotoConditionsAccepted = (val: boolean | undefined) => {
        if (this.state.model.photoConditionsAccepted !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.photoConditionsAccepted = val;

            this.setState({ model: newModel });
        }
    }

    public setPhotoMarketingPurposes = (val: boolean | undefined) => {
        if (this.state.model.photoMarketingPurposes !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.photoMarketingPurposes = val;

            this.setState({ model: newModel });
        }
    }

    public setHomeInternetDataLimitValue = (event) => {
        if (this.state.model.homeInternetDataLimitValue !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.homeInternetDataLimitValue = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setMobileInternetDataLimitValue = (event) => {
        if (this.state.model.mobileInternetDataLimitValue !== event.target.value) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.mobileInternetDataLimitValue = event.target.value;

            this.setState({ model: newModel });
        }
    }

    public setTransportPublicTransport = (event) => {
        let newModel = this.state.model;
        newModel.transportPublicTransport = event.target.checked;
        this.setState({ model: newModel });
    }

    public setTransportWalk = (event) => {
        let newModel = this.state.model;
        newModel.transportWalk = event.target.checked;
        this.setState({ model: newModel });
    }

    public setTransportBike = (event) => {
        let newModel = this.state.model;
        newModel.transportBike = event.target.checked;
        this.setState({ model: newModel });
    }

    public setTransportMotorBike = (event) => {
        let newModel = this.state.model;
        newModel.transportMotorBike = event.target.checked;
        this.setState({ model: newModel });
    }

    public setTransportOwnVehicle = (event) => {
        let newModel = this.state.model;
        newModel.transportOwnVehicle = event.target.checked;
        this.setState({ model: newModel });
    }

    public setTransportCarShare = (event) => {
        let newModel = this.state.model;
        newModel.transportCarShare = event.target.checked;
        this.setState({ model: newModel });
    }

    public setPrivacyNoticeAccepted = (val: boolean | undefined) => {
        if (this.state.model.privacyNoticeAccepted !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.privacyNoticeAccepted = val;

            this.setState({ model: newModel });
        }
    }

    public setAllowESALearningOpportunities = (val: boolean | undefined) => {
        if (this.state.model.allowESALearningOpportunities !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.allowESALearningOpportunities = val;

            this.setState({ model: newModel });
        }
    }

    public setAllowESAResearch = (val: boolean | undefined) => {
        if (this.state.model.allowESAResearch !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.allowESAResearch = val;

            this.setState({ model: newModel });
        }
    }

    public setAllowESAContactByPost = (val: boolean | undefined) => {
        if (this.state.model.allowESAContactByPost !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.allowESAContactByPost = val;

            this.setState({ model: newModel });
        }
    }

    public setAllowESAContactByTelephone = (val: boolean | undefined) => {
        if (this.state.model.allowESAContactByTelephone !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.allowESAContactByTelephone = val;

            this.setState({ model: newModel });
        }
    }

    public setAllowESAContactByEmail = (val: boolean | undefined) => {
        if (this.state.model.allowESAContactByEmail !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.allowESAContactByEmail = val;

            this.setState({ model: newModel });
        }
    }

    public setAllowMarketing = (val: boolean | undefined) => {
        if (this.state.model.allowMarketing !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.allowMarketing = val;
            newModel.allowPhone = undefined;
            newModel.allowPost = undefined;
            newModel.allowSocialMedia = undefined;
            newModel.allowEmail = undefined;

            this.setState({ model: newModel });
        }
    }

    public setAllowSocialMedia = (val: boolean | undefined) => {
        if (this.state.model.allowSocialMedia !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.allowSocialMedia = val;

            this.setState({ model: newModel });
        }
    }

    public setAllowPhone = (val: boolean | undefined) => {
        if (this.state.model.allowPhone !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.allowPhone = val;

            this.setState({ model: newModel });
        }
    }

    public setAllowPost = (val: boolean | undefined) => {
        if (this.state.model.allowPost !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.allowPost = val;

            this.setState({ model: newModel });
        }
    }

    public setAllowEmail = (val: boolean | undefined) => {
        if (this.state.model.allowEmail !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.allowEmail = val;

            this.setState({ model: newModel });
        }
    }

    public setEnrolmentConfirmed = (val: boolean | undefined) => {
        if (this.state.model.enrolmentConfirmed !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.enrolmentConfirmed = val;

            this.setState({ model: newModel });
        }
    }

    public setEnrolmentParentConfirmed = (val: boolean | undefined) => {
        if (this.state.model.enrolmentParentConfirmed !== val) {
            let newModel: EnrolmentFormViewModel = this.state.model;
            newModel.enrolmentParentConfirmed = val;

            this.setState({ model: newModel });
        }
    }

    private verifyEmail = (value): Promise<boolean> => {
        return fetch('https://pce.afd.co.uk/afddata.pce?serial=831224&password=1ZS6gcv2&Data=Email&Task=Full&Fields=Standard&Email=' + encodeURIComponent(value), {
            mode: 'cors',
        })
            .then(response => response.text()).then((data) => {
                let emailResult = parser.parse(data);

                if (emailResult.AFDPostcodeEverywhere.Result > 0) {
                    return true;
                } else {
                    return false;
                }
            });
    }

    private verifyPhone = (value): Promise<boolean> => {
        return fetch('https://pce.afd.co.uk/afddata.pce?Serial=831224&Password=1ZS6gcv2&UserID=HULLC01&Data=Phone&Task=Full&Fields=Standard&Phone=' + encodeURIComponent(value), {
            mode: 'cors',
        })
            .then(response => response.text()).then((data) => {
                let phoneResult = parser.parse(data);

                if (phoneResult.AFDPostcodeEverywhere.Result > 0) {
                    return true;
                } else {
                    return false;
                }
            });
    }

    private setPhoto = (photo: Promise<File>) => {
        let newModel = this.state.model;
        if (photo === undefined) {
            newModel.photo = undefined;
            this.setState({ model: newModel });
        } else {
            //newModel.photo = photo;
            photo.then((data) => {
                newModel.photo = data;
                this.setState({ model: newModel });
            });
        }
    }

    private onError = async (event) => {
        this.setState({ formInvalid: true });
    }

    private save = async (event) => {
        event.preventDefault();

        if (this.state.saving !== true) {
            this.setState({ saving: true });
            if (this.state.model.learningDifficultyDisabilityResponse === "1") {
                if (this.state.model.disabilitySelection !== null && this.state.model.disabilitySelection !== undefined && this.state.model.disabilitySelection.length > 0) {
                    this.setState({ disailityInvalid: false })
                } else {
                    this.setState({ saving: false, formInvalid: false, disailityInvalid: true });
                    return;
                }
            }

            console.log(3);
            let mobValid: boolean = true;
            if (this.state.model.mobilePhoneNumber !== undefined && this.state.model.mobilePhoneNumber !== '') {
                mobValid = await this.verifyPhone(this.state.model.mobilePhoneNumber);
            }

            let phoneValid: boolean = true;
            if (this.state.model.landlinePhoneNumber !== undefined && this.state.model.landlinePhoneNumber !== '') {
                phoneValid = await this.verifyPhone(this.state.model.landlinePhoneNumber);
            }

            let emailValid: boolean = true;
            if (this.state.model.email !== undefined && this.state.model.email !== '') {
                emailValid = await this.verifyEmail(this.state.model.email);
            }

            let contactMobValid: boolean = true;
            if (this.state.model.contactMobilePhoneNumber !== undefined && this.state.model.contactMobilePhoneNumber !== '') {
                contactMobValid = await this.verifyPhone(this.state.model.contactMobilePhoneNumber);
            }

            let contactTelValid: boolean = true;
            if (this.state.model.contactLandlinePhoneNumber !== undefined && this.state.model.contactLandlinePhoneNumber !== '') {
                contactTelValid = await this.verifyPhone(this.state.model.contactLandlinePhoneNumber);
            }

            let contactEmailValid: boolean = true;
            if (this.state.model.contactEmail !== undefined && this.state.model.contactEmail !== '') {
                contactEmailValid = await this.verifyEmail(this.state.model.contactEmail);
            }

            let termTimePhoneValid: boolean = true;
            if (this.state.model.termTimePhoneNumber !== undefined && this.state.model.termTimePhoneNumber !== '') {
                termTimePhoneValid = await this.verifyPhone(this.state.model.termTimePhoneNumber);
            }

            let parent1MobValid: boolean = true;
            if (this.state.model.parent1MobTel !== undefined && this.state.model.parent1MobTel !== '') {
                parent1MobValid = await this.verifyPhone(this.state.model.parent1MobTel);
            }

            let parent1TelValid: boolean = true;
            if (this.state.model.parent1HomeTel !== undefined && this.state.model.parent1HomeTel !== '') {
                parent1TelValid = await this.verifyPhone(this.state.model.parent1HomeTel);
            }

            let parent1WorkTelValid: boolean = true;
            if (this.state.model.parent1WorkTel !== undefined && this.state.model.parent1WorkTel !== '') {
                parent1WorkTelValid = await this.verifyPhone(this.state.model.parent1WorkTel);
            }

            let parent1EmailValid: boolean = true;
            if (this.state.model.parent1EmailAddress !== undefined && this.state.model.parent1EmailAddress !== '') {
                parent1EmailValid = await this.verifyEmail(this.state.model.parent1EmailAddress);
            }

            let parent2MobValid: boolean = true;
            if (this.state.model.parent2MobTel !== undefined && this.state.model.parent2MobTel !== '') {
                parent2MobValid = await this.verifyPhone(this.state.model.parent2MobTel);
            }

            let parent2TelValid: boolean = true;
            if (this.state.model.parent2HomeTel !== undefined && this.state.model.parent2HomeTel !== '') {
                parent2TelValid = await this.verifyPhone(this.state.model.parent2HomeTel);
            }

            let parent2WorkTelValid: boolean = true;
            if (this.state.model.parent2WorkTel !== undefined && this.state.model.parent2WorkTel !== '') {
                parent2WorkTelValid = await this.verifyPhone(this.state.model.parent2WorkTel);
            }

            let parent2EmailValid: boolean = true;
            if (this.state.model.parent2EmailAddress !== undefined && this.state.model.parent2EmailAddress !== '') {
                parent2EmailValid = await this.verifyEmail(this.state.model.parent2EmailAddress);
            }

            if (parent2EmailValid && parent2WorkTelValid && parent2TelValid && parent2MobValid && parent1EmailValid && parent1WorkTelValid && parent1TelValid && parent1MobValid && termTimePhoneValid && contactEmailValid && contactTelValid && contactMobValid && emailValid && phoneValid && mobValid) {
                
                let formData = new FormData(event.target);
                if (this.state.model.photo !== undefined) {
                    formData.append("photo", this.state.model.photo);
                }

                if (this.state.model.academicYearId !== undefined) {
                    formData.append("academicYearId", this.state.model.academicYearId);
                }

                if (this.props.model.refNo !== undefined) {
                    formData.append("refNo", this.props.model.refNo);
                }

                if (this.props.model.studentId !== undefined) {
                    formData.append("studentId", this.props.model.studentId.toString());
                }

                if (this.props.model.offeringId !== undefined) {
                    formData.append("offeringId", this.props.model.offeringId);
                }

                if (this.props.model.enrolmentType !== undefined) {
                    formData.append("enrolmentType", this.props.model.enrolmentType);
                }

                if (this.state.model.dateofBirth !== undefined) {
                    formData.append("dateofBirth", this.state.model.dateofBirth !== undefined ? new Date(this.state.model.dateofBirth.toString()).toUTCString() : new Date().toUTCString());
                }

                if (this.state.model.schoolAttendedFrom !== undefined) {
                    formData.append("schoolAttendedFrom", this.state.model.schoolAttendedFrom !== undefined ? new Date(this.state.model.schoolAttendedFrom.toString()).toUTCString() : new Date().toUTCString());
                }

                if (this.state.model.schoolAttendedTo !== undefined) {
                    formData.append("schoolAttendedTo", this.state.model.schoolAttendedTo !== undefined ? new Date(this.state.model.schoolAttendedTo.toString()).toUTCString() : new Date().toUTCString());
                }

                
                console.log(this.state.model.euroResidentDate);
                if (this.state.model.euroResident === false) {
                    formData.append("euroResidentDate", this.state.model.euroResidentDate !== undefined ? this.state.model.euroResidentDate.toUTCString() : new Date(Date.now()).toUTCString());
                }
                

                if (this.state.model.employedFrom !== undefined) {
                    formData.append("employedFrom", this.state.model.employedFrom !== undefined ? new Date(this.state.model.employedFrom.toString()).toUTCString() : new Date().toUTCString());
                }

                if (this.state.model.unemployedFrom !== undefined) {
                    formData.append("unemployedFrom", this.state.model.unemployedFrom !== undefined ? new Date(this.state.model.unemployedFrom.toString()).toUTCString() : new Date().toUTCString());
                }

                if (this.state.model.signature !== undefined) {
                    formData.append("signature", this.state.model.signature);
                }

                if (this.state.model.signatureParent !== undefined) {
                    formData.append("signatureParent", this.state.model.signatureParent);
                }

                if (this.state.model.disabilitySelection !== undefined) {
                    formData.append("disabilitySelectionJSON", JSON.stringify(this.state.model.disabilitySelection));
                }

                console.log(8);
                if (this.state.model.englishFSQuestion !== undefined) {
                    formData.append("englishFSQuestion", this.state.model.englishFSQuestion.toString());
                }
                console.log(9);
                if (this.state.model.englishLitFSQuestion !== undefined) {
                    formData.append("englishLitFSQuestion", this.state.model.englishLitFSQuestion.toString());
                }
                console.log(10);
                if (this.state.model.mathsFSQuestion !== undefined) {
                    formData.append("mathsFSQuestion", this.state.model.mathsFSQuestion.toString());
                }
                console.log(11);
                if (this.state.model.feesAndFunding !== undefined) {
                    formData.append("feesAndFunding", this.state.model.feesAndFunding.toString());
                }
                console.log(12);
                if (this.state.model.feesAndFundingSource !== undefined) {
                    formData.append("feesAndFundingSource", this.state.model.feesAndFundingSource.toString());
                }
                console.log(13);

                fetch('api/Enrolment/Save', {
                    method: 'POST',
                    //headers: { 'Content-Type': 'mutlipart/form-data' },
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    body: formData
                }).then((data) => {
                    if (data !== null && data !== undefined && data.status == 200) {
                        this.setState({ saving: false }, () => this.props.setComplete(true));
                    } else {
                        this.setState({ saving: false });
                        window.scrollTo(0, 0);
                    }
                }).catch((error) => {
                    console.log(error);
                    this.setState({ saving: false });
                    window.scrollTo(0, 0);
                });
            } else {
                let invalidFields: string = '';

                if (!mobValid) {
                    invalidFields += ' \n Mobile Phone Number'
                }
                if (!phoneValid) {
                    invalidFields += '\n Home Phone Number '
                }
                if (!emailValid) {
                    invalidFields += '\n Email Address '
                }
                if (!contactMobValid) {
                    invalidFields += '\n Emergency Contact Mobile Phone Number'
                }
                if (!contactTelValid) {
                    invalidFields += '\n Emergency Contact Home Phone Number '
                }
                if (!contactEmailValid) {
                    invalidFields += '\n Emergency Contact Email Address '
                }
                if (!termTimePhoneValid) {
                    invalidFields += '\n Term Time Phone Number '
                }
                if (!parent1MobValid) {
                    invalidFields += '\n First Parent/Guardian Mobile Phone Number '
                }
                if (!parent1TelValid) {
                    invalidFields += '\n First Parent/Guardian Emergency Phone Number '
                }
                if (!parent1WorkTelValid) {
                    invalidFields += '\n First Parent/Guardian Work Phone Number '
                }
                if (!parent1EmailValid) {
                    invalidFields += '\n First Parent/Guardian Email Address '
                }
                if (!parent2MobValid) {
                    invalidFields += '\n Second Parent/Guardian Mobile Phone Number '
                }
                if (!parent2TelValid) {
                    invalidFields += '\n Second Parent/Guardian Emergency Phone Number '
                }
                if (!parent2WorkTelValid) {
                    invalidFields += '\n Second Parent/Guardian Work Phone Number '
                }
                if (!parent2EmailValid) {
                    invalidFields += '\n Second Parent/Guardian Email Address '
                }

                this.setState({ phonesAndEmailsValid: false, phonesAndEmailsErrors: invalidFields, saving: false });
                window.scrollTo(0, 0);
            }
        }
    }

}

export default withStyles(styles)(EnrolmentForm);

